import { AfterViewInit, Component, ElementRef, HostListener, NgZone, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { OrdenesService } from 'src/app/services/transacciones/ordenes.service';
import { SimpleDataTable } from 'src/app/shared/data/tables_data/data_table';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { Usuario } from 'src/app/authentication/interfaces/interfaces';
import { AuthService } from 'src/app/authentication/auth.service';
import { DoctoresService } from 'src/app/services/personas/doctores.service';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { InformesRxService } from 'src/app/services/transacciones/informes-rx.service';
import { CalendarOptions } from '@fullcalendar/core'; // useful for typechecking
import dayGridPlugin from '@fullcalendar/daygrid';
import esLocale from '@fullcalendar/core/locales/es'; 
import { th } from 'date-fns/locale';

@Component({
    selector: 'app-inicio',
    templateUrl: './inicio.component.html',
    styleUrls: ['./inicio.component.scss'],
    standalone: false
})
export class InicioComponent implements OnInit, AfterViewInit, OnDestroy {

  calendarOptions!: CalendarOptions;

  title = 'datatables';
  dtOptions: DataTables.Settings = {};
  dtOptionsSN: DataTables.Settings = {};
  dtOptionsCitaPendiente: DataTables.Settings = {};
  dtOptionsFacturadasCita: DataTables.Settings = {};

  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;
  @ViewChild('mobileCameraInput', { static: false })
  mobileCameraInput?: ElementRef<HTMLInputElement>;
  @ViewChild('mobilePreviewModal', { static: false })
  mobilePreviewModal?: TemplateRef<any>;
  @ViewChild('mobileUploadingModal', { static: false })
  mobileUploadingModal?: TemplateRef<any>;

  posts: any = [];
  ordenes;
  ordenesPendienteCita:any = [];
  ordenesFacturadasCita:any = [];

  ColumnMode = ColumnMode;
  public isMobileView = false;
  public buscarOrden: string = "";
  public pageNumber: number;
  public size: number;
  public spinnerPaginado: boolean = true;

  public secuenciasList: any = [];
  public totalElements: number;
  public spinnerBoolean: boolean = false;
  public totalPaginas: number = 0;
  public totalSeleccionado: number = 0;
  public timeout: any;
  public atributoBusqueda = "NOM_CLI";
  public atributoSecuencia = "";
  public codigoOrden = "";
  public codigoDoctor = "";
  public nombreDoctor = "";
  public telefonoDoctor = "";
  public nombreCliente = "";

  private linkAnterior: string = environment.systemLegacyUrl;
  public spinnerBooleanAsignarOrden: boolean = false;
  public estado: string = "pendiente";
  private _usuario!: Usuario;
  public idSucursal!: string;
  public perfilUsuario!: string;
  public tipoBusqueda: string = "normal";
  public doctoreslist!: any[];
  public selectedDoctor: string = "";
  public idOrden: string = "";
  public numeroOrden: string = "";
  public secuenciaFisica: string = "";
  public contr = 0;
  public nuevoCorreoElectronico: string = "";
  public selected: string = "";
  public pacienteSecuencia: string = "";
  public doctorSecuencia: string = "";
  public asesorSencuencia: string = "";
  public nombreSucursal: string = "";
  public estadoDT: string = '';
  public perfil: string = '';
  public myTable: boolean = false;
  public idUsuario!:string;
  public codeUserModify:number = 0;
  public txtOrdenFisica: string = "";
  activeTab: string = '1';
  public nombreDoctorModificar:string = "";
  public tipoVistaCitaPrevia:string = "vista-tabla";
  public pagina;
  public busqueda;
  public limite;
  public ordenesTomData: any[] = [];
  public totalTom: number = 0;
  public busquedaTom: string = '';
  public paginaTom: number = 1;
  public readonly itemsPorPaginaTom: number = 10;
  private tomoModo: 'dicon' | 'normal' = 'dicon';
  private tomoSearchTimer: any = null;
  public mostrarCitaPrevia = false;
  public mostrarTipoVisualizacion = true;
  public modifyDoctor = [1,16, 112, 134];//USUARIOS PERMITIDOS MODIFICAR
  public idOrdenFisc :string = "";
  public auditoriaSubidas: any[] = [];
  public auditoriaTotal = 0;
  public auditoriaPagina = 1;
  public auditoriaLimite = 25;
  public auditoriaBusqueda = '';
  public auditoriaCargando = false;
  public auditoriaOrdenSeleccionada = '';
  public auditoriaNumeroOrdenSeleccionada = '';
  public archivosAuditoriaSeleccionados: any[] = [];
  public ordenResultadosSeleccionada: any = null;
  public enviosResultadosCompletados = new Set<string>();
  public enviosResultadosProcesando = new Set<string>();

  max =  new Date().getFullYear();
  //Retso el año - 10 para mostrar en el select de años
  min = this.max - 4;
  aniosFiltro:any = [];
  public anioSeleccionado = this.max;

  columns = [
    { prop: 'numeroFacturaOrden' },
    { prop: 'NUM_ORD' },
    { prop: 'NOM_CLI' },
    { prop: 'CEL_CLI' },
    { prop: 'FEC_CLI' },
    { prop: 'CODN_DOC' },
    { prop: 'NOM_DOC' },
    { prop: 'DIR_SURC' },
    { prop: 'fecha' },
    { prop: 'tipo' },
    { prop: 'FEC_ORD' },
    { prop: 'responsable' },
    { prop: 'Acciones' }
  ];
  private mobileTablesObserver?: MutationObserver;
  private mobileLabelsRaf?: number;
  private pendingMobileOrderId?: string;
  private mobileDefaultApplied = false;
  public mobileUploading = false;
  public mobilePreviewImage: string = '';
  public showDownloadButton: boolean = false;
  private mobilePreviewRef?: NgbModalRef;
  private mobileUploadingRef?: NgbModalRef;
  private readonly mobilePhysicalOrderMaxDimension = 1600;
  private readonly mobilePhysicalOrderJpegQuality = 0.78;

  public codigosPaqueteModal: any[] = [];
  public codigosPaqueteFiltrados: any[] = [];
  public busquedaCodigoPaquete: string = '';
  public paginaCodigoPaquete: number = 1;
  public itemsPorPaginaPaquete: number = 10;
  public paqueteSeleccionadoCod: any = null;
  public totalPaginasCodigos: number = 0;
  private modalCodigosPaqueteRef?: NgbModalRef;

  // Permisos granulares de Inicio (tabs + nueva transacción)
  private readonly PERM_TAB_PENDIENTES = 'transacciones.ordenes.tab.pendientes';
  private readonly PERM_TAB_PENDIENTES_FACTURADAS = 'transacciones.ordenes.tab.pendientes_facturadas';
  private readonly PERM_TAB_ATENDIDAS = 'transacciones.ordenes.tab.atendidas';
  private readonly PERM_TAB_ANULADAS = 'transacciones.ordenes.tab.anuladas';
  private readonly PERM_TAB_PAQUETES = 'transacciones.ordenes.tab.paquetes';
  private readonly PERM_TAB_TOMOGRAFIA_DICOM = 'transacciones.ordenes.tab.tomografia_dicom';
  private readonly PERM_TAB_TOMOGRAFIA = 'transacciones.ordenes.tab.tomografia';

  private readonly PERM_NUEVA_ORDEN_FACTURA = 'transacciones.ordenes.nueva.electronica_factura';
  private readonly PERM_NUEVA_ORDEN_CONVENIO = 'transacciones.ordenes.nueva.electronica_convenio';
  private readonly PERM_NUEVA_ORDEN_FISICA_FACTURA = 'transacciones.ordenes.nueva.fisica_factura';
  private readonly PERM_NUEVA_ORDEN_FISICA_SIN_FACTURA = 'transacciones.ordenes.nueva.fisica_sin_factura';
  private readonly PERM_NUEVA_ORDEN_CITA_PREVIA = 'transacciones.ordenes.nueva.electronica_cita_previa';

  constructor(private ordenesService: OrdenesService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    public router: Router,
    public route: ActivatedRoute,
    private doctoresService: DoctoresService,
    private authService: AuthService,
    private informesRxService: InformesRxService,
    private elementRef: ElementRef,
    private ngZone: NgZone) {

    this.pageNumber = 0;
    this.size = 10;
    this.totalElements = 0;
    this._usuario = authService.loginUsuario;

  }

  get canVerTabPendientes(): boolean {
    return this.authService.hasPermission(this.PERM_TAB_PENDIENTES);
  }

  get canVerTabPendientesFacturadas(): boolean {
    return this.authService.hasPermission(this.PERM_TAB_PENDIENTES_FACTURADAS);
  }

  get canVerTabAtendidas(): boolean {
    return this.authService.hasPermission(this.PERM_TAB_ATENDIDAS);
  }

  get canVerTabAnuladas(): boolean {
    return this.authService.hasPermission(this.PERM_TAB_ANULADAS);
  }

  get canVerTabPaquetes(): boolean {
    return this.authService.hasPermission(this.PERM_TAB_PAQUETES);
  }

  get canVerTabTomografiaDicom(): boolean {
    return this.authService.hasPermission(this.PERM_TAB_TOMOGRAFIA_DICOM);
  }

  get canVerTabTomografia(): boolean {
    return this.authService.hasPermission(this.PERM_TAB_TOMOGRAFIA);
  }

  get canCrearOrdenElectronicaFactura(): boolean {
    return this.authService.hasPermission(this.PERM_NUEVA_ORDEN_FACTURA);
  }

  get canCrearOrdenElectronicaConvenio(): boolean {
    return this.authService.hasPermission(this.PERM_NUEVA_ORDEN_CONVENIO);
  }

  get canCrearOrdenFisicaFactura(): boolean {
    return this.authService.hasPermission(this.PERM_NUEVA_ORDEN_FISICA_FACTURA);
  }

  get canCrearOrdenFisicaSinFactura(): boolean {
    return this.authService.hasPermission(this.PERM_NUEVA_ORDEN_FISICA_SIN_FACTURA);
  }

  get canCrearOrdenElectronicaCitaPrevia(): boolean {
    return this.authService.hasPermission(this.PERM_NUEVA_ORDEN_CITA_PREVIA);
  }

  get canVerMenuNuevaTransaccion(): boolean {
    return this.authService.hasAnyPermission([
      this.PERM_NUEVA_ORDEN_FACTURA,
      this.PERM_NUEVA_ORDEN_CONVENIO,
      this.PERM_NUEVA_ORDEN_FISICA_FACTURA,
      this.PERM_NUEVA_ORDEN_FISICA_SIN_FACTURA,
      this.PERM_NUEVA_ORDEN_CITA_PREVIA
    ]);
  }

  get canVerAuditoriaSubidas(): boolean {
    return this.authService.hasPermission('auditoria.subidas.read');
  }

  abrirAuditoriaOrden(modal: TemplateRef<any>, idOrden: string | number, numeroOrden: string): void {
    this.auditoriaPagina = 1;
    this.auditoriaOrdenSeleccionada = String(idOrden);
    this.auditoriaNumeroOrdenSeleccionada = numeroOrden;
    this.auditoriaBusqueda = '';
    this.cargarAuditoriaSubidas();
    this.modalService.open(modal, { size: 'xl', scrollable: true });
  }

  abrirGestionResultados(modal: TemplateRef<any>, orden: any): void {
    this.ordenResultadosSeleccionada = orden;
    this.enviosResultadosCompletados.clear();
    this.enviosResultadosProcesando.clear();
    const modalRef = this.modalService.open(modal, { size: 'lg', centered: true, scrollable: true });
    modalRef.result.then(
      () => this.reiniciarEstadoEnviosResultados(),
      () => this.reiniciarEstadoEnviosResultados()
    );
  }

  resultadoFueEnviado(clave: string): boolean {
    return this.enviosResultadosCompletados.has(clave);
  }

  resultadoSeEstaEnviando(clave: string): boolean {
    return this.enviosResultadosProcesando.has(clave);
  }

  private iniciarEnvioResultado(clave: string): boolean {
    if (
      this.enviosResultadosProcesando.has(clave) ||
      this.enviosResultadosCompletados.has(clave)
    ) {
      return false;
    }
    this.enviosResultadosProcesando.add(clave);
    return true;
  }

  private marcarResultadoEnviado(clave: string): void {
    this.enviosResultadosProcesando.delete(clave);
    this.enviosResultadosCompletados.add(clave);
  }

  private liberarEnvioResultado(clave: string): void {
    this.enviosResultadosProcesando.delete(clave);
  }

  private reiniciarEstadoEnviosResultados(): void {
    this.enviosResultadosCompletados.clear();
    this.enviosResultadosProcesando.clear();
    this.ordenResultadosSeleccionada = null;
  }

  private claveEnvioTomografia(item: string, canal: 'email' | 'whatsapp'): string {
    const tipo = item.includes('DIC') ? 'dicom' : 'normal';
    return `tomografia:${tipo}:${canal}`;
  }

  cargarAuditoriaSubidas(): void {
    this.auditoriaCargando = true;
    const offset = (this.auditoriaPagina - 1) * this.auditoriaLimite;
    this.ordenesService.listarAuditoriaSubidas(
      this.auditoriaLimite,
      offset,
      this.auditoriaBusqueda,
      this.auditoriaOrdenSeleccionada
    )
      .subscribe({
        next: (resp) => {
          this.auditoriaSubidas = resp.registros || [];
          this.auditoriaTotal = Number(resp.total || 0);
          this.auditoriaCargando = false;
        },
        error: () => {
          this.auditoriaCargando = false;
          this.toastr.error('No se pudo consultar la auditoría de subidas', 'Atención');
        }
      });
  }

  cambiarPaginaAuditoria(pagina: number): void {
    if (pagina < 1 || pagina > this.auditoriaTotalPaginas) return;
    this.auditoriaPagina = pagina;
    this.cargarAuditoriaSubidas();
  }

  get auditoriaTotalPaginas(): number {
    return Math.max(1, Math.ceil(this.auditoriaTotal / this.auditoriaLimite));
  }

  resumenArchivosAuditoria(registro: any): string {
    try {
      const detalle = JSON.parse(registro.detalle_archivos || '{}');
      const etiquetas = [
        this.formatearCantidadArchivo(detalle.imagenes, 'imagen', 'imágenes'),
        this.formatearCantidadArchivo(detalle.documentos, 'documento', 'documentos'),
        this.formatearCantidadArchivo(detalle.videos, 'video', 'videos'),
        this.formatearCantidadArchivo(detalle.informe, 'informe', 'informes')
      ].filter(Boolean);
      return etiquetas.length ? etiquetas.join(' · ') : 'Sin archivos nuevos';
    } catch {
      return `${registro.cantidad_archivos || 0} archivo(s)`;
    }
  }

  archivosAuditoria(registro: any): any[] {
    try {
      const archivos = JSON.parse(registro.archivos_urls || '[]');
      return Array.isArray(archivos) ? archivos : [];
    } catch {
      return [];
    }
  }

  abrirArchivosAuditoria(modal: TemplateRef<any>, registro: any): void {
    this.archivosAuditoriaSeleccionados = this.archivosAuditoria(registro);
    this.modalService.open(modal, { size: 'lg', centered: true, scrollable: true });
  }

  esImagenAuditoria(archivo: any): boolean {
    return archivo?.categoria === 'Imagen' || ['jpg', 'jpeg', 'png', 'webp'].includes(String(archivo?.tipo || '').toLowerCase());
  }

  esVideoAuditoria(archivo: any): boolean {
    return archivo?.categoria === 'Video' || ['mp4', 'webm', 'ogg'].includes(String(archivo?.tipo || '').toLowerCase());
  }

  private formatearCantidadArchivo(cantidad: any, singular: string, plural: string): string {
    const total = Number(cantidad || 0);
    if (total <= 0) return '';
    return `${total} ${total === 1 ? singular : plural}`;
  }
  

  ngOnInit(): void {
    this.idSucursal = this._usuario.sucursal!;
    this.nombreSucursal = this._usuario.nombreSucursal!;
    this.perfil = this._usuario.perfil!;
    this.idUsuario = this._usuario.idUsuario!;
    this.codeUserModify =  parseInt(this._usuario.idUsuario!);
    let citaPrevia = this._usuario.citaPrevia!;
    this.llenarAniosFiltro();
    this.ordenes = [];
    //this.setPage({ offset: 0 });
    this.mostrarCitaPrevia = citaPrevia == 1 ? true : false;

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      order: [[5, 'desc']],
      language: LanguageApp.spanish_datatables
    };

    this.detectMobileView();

    this.dtPendienteCitaPrevia('pendiente');
    this.dtFacturadasCitaPrevia('facturadas');
    this.abrirPestanaInicial();

    if (this._usuario.perfil == "ecografo") {
      this.router.navigate(['sistema/ecografias']);
    }

  }

  ngAfterViewInit(): void {
    this.initializeMobileTables();
  }

  ngOnDestroy(): void {
    this.mobileTablesObserver?.disconnect();
    if (this.mobileLabelsRaf) {
      cancelAnimationFrame(this.mobileLabelsRaf);
    }
  }

  //GENERAR ANIOS DINAMICOS
  llenarAniosFiltro(){
    for(let i = this.max; i >= this.min; i--){
      this.aniosFiltro.push(i);
    }
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.detectMobileView();
  }

  private detectMobileView(): void {
    if (typeof window === 'undefined') {
      this.isMobileView = false;
      return;
    }
    const previousValue = this.isMobileView;
    this.isMobileView = window.innerWidth <= 992;

    if (this.isMobileView && !this.mobileDefaultApplied) {
      this.mobileDefaultApplied = true;
    } else if (!this.isMobileView && previousValue !== this.isMobileView) {
      this.mobileDefaultApplied = false;
    }
  }

  private abrirPestanaInicial(): void {
    if (this.isMobileView && this.canVerTabPendientesFacturadas) {
      this.activeTab = '2';
      this.cargarEstadoInicial('facturadas', 'normal');
      return;
    }

    if (this.canVerTabPendientes) {
      this.activeTab = '1';
      this.cargarEstadoInicial('pendiente', 'normal');
      return;
    }

    if (this.canVerTabPendientesFacturadas) {
      this.activeTab = '2';
      this.cargarEstadoInicial('facturadas', 'normal');
      return;
    }

    if (this.canVerTabAtendidas) {
      this.activeTab = '3';
      this.cargarEstadoInicial('con-imagenes', 'normal');
      return;
    }

    if (this.canVerTabAnuladas) {
      this.activeTab = '6';
      this.cargarEstadoInicial('anulado', 'normal');
      return;
    }

    if (this.canVerTabPaquetes) {
      this.activeTab = '7';
      this.getPaquete();
      return;
    }

    if (this.canVerTabTomografiaDicom) {
      this.activeTab = '9';
      this.dtTomografiaDicom();
      return;
    }

    if (this.canVerTabTomografia) {
      this.activeTab = '10';
      this.dtTomografia();
    }
  }

  private cargarEstadoInicial(estado: string, tipo: string): void {
    this.estadoDT = '';
    this.cambiarEstado(estado, tipo);
  }

  private initializeMobileTables(): void {
    if (typeof window === 'undefined') {
      return;
    }

    this.updateMobileTableLabels();

    this.ngZone.runOutsideAngular(() => {
      if (typeof MutationObserver === 'undefined') {
        return;
      }

      this.mobileTablesObserver?.disconnect();
      this.mobileTablesObserver = new MutationObserver(() => this.updateMobileTableLabels());
      this.mobileTablesObserver.observe(this.elementRef.nativeElement, { childList: true, subtree: true });
    });
  }

  private updateMobileTableLabels(): void {
    if (typeof window === 'undefined') {
      return;
    }

    if (this.mobileLabelsRaf) {
      cancelAnimationFrame(this.mobileLabelsRaf);
    }

    this.mobileLabelsRaf = window.requestAnimationFrame(() => {
      const hostElement = this.elementRef.nativeElement as HTMLElement;
      const tables = Array.from(hostElement.querySelectorAll<HTMLTableElement>('.mobile-friendly-table'));

      tables.forEach((table) => {
        const headers = Array.from(table.querySelectorAll<HTMLTableCellElement>('thead th')).map((th) => th.textContent?.trim() ?? '');

        table.querySelectorAll('tbody tr').forEach((row) => {
          row.querySelectorAll<HTMLTableCellElement>('td').forEach((cell, index) => {
            const headerText = headers[index];
            if (headerText && cell.getAttribute('data-label') !== headerText) {
              cell.setAttribute('data-label', headerText);
            }
          });
        });
      });
    });
  }

  filtrarOrdenesPorAnio(value){
    this.anioSeleccionado = value;
    
    this.reload();
  }

  reload() {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.ajax.reload();
    });
  }
 
  datatableOrdenes() {

    const that = this;
    that.ordenes = [];
    this.myTable = false;

    let lastPage = 0;
    let lastSearchText = "";
    this.dtOptionsSN = {
      language: LanguageApp.spanish_datatables,
      pagingType: 'full_numbers',
      pageLength: 10,
      displayStart: lastPage, // Last Selected Page
      search: { search: lastSearchText }, // Last Searched Text
      serverSide: true,
      // processing: true,
      responsive: true,
      retrieve: true,
      orderClasses: false,
      processing: true,
      deferRender: true,
      searchDelay: 1500,
      ajax: (dataTablesParameters: any, callback) => {

        this.ngZone.run(() => { this.ordenes = []; });

        this.pagina = dataTablesParameters.start;
        this.busqueda = dataTablesParameters.search.value;
        this.limite = dataTablesParameters.length;

        this.ordenesService.datatableOrdenesFiltro(
          this.estadoDT,
          this.perfil,
          this.idSucursal,
          this.limite,
          this.pagina,
          this.busqueda,
          this.anioSeleccionado
        ).subscribe(resp => {

          this.ngZone.run(() => {
            this.ordenes = resp.data;
            this.spinnerBoolean = false;
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });

        })

      }
    }
  }

  cambiarVisualizacionCitas(tipoVisualizacion){
    this.mostrarTipoVisualizacion = tipoVisualizacion == "vista-tabla" ? true : false;
  }


  /* -------------------------------------------------------------------------- */
  /*                           MOSTRAR ORDENES PAQUETE                          */
  /* -------------------------------------------------------------------------- */
  getPaquete() {

    this.spinnerBoolean = true;
    this.posts = [];
    /* -------------------------------------------------------------------------- */
    /*                        OBTENER TRANSACCIONES PAQUETE                       */
    /* -------------------------------------------------------------------------- */
    this.ordenesService.obtenerPaquetes(localStorage.getItem('token'), 'paquete', null, null).subscribe((resp) => {

      this.posts = resp.rows;
      this.spinnerBoolean = false;

    });

  }

  /* -------------------------------------------------------------------------- */
  /*                               CARGAR PAGINAS                               */
  /* -------------------------------------------------------------------------- */
  /*setPage(pageInfo) {
    //pageInfo.offset = 0;
    
    this.totalPaginas = (pageInfo.count/pageInfo.limit);
     this.totalSeleccionado = (Number(pageInfo.offset) * Number(pageInfo.count))/ parseInt(this.totalPaginas.toString());
     if(this.totalSeleccionado>=this.totalPaginas){

      this.totalSeleccionado = this.totalSeleccionado-10
     }
    this.pageNumber = pageInfo.offset;
  
    if(pageInfo.offset <= 0){

      this.pageNumber =pageInfo.offset;
      this.totalSeleccionado =  0;
    }
  
    console.log(pageInfo);
    

    let busqued = "vacio";

    if (this.buscarOrden != "") {
      busqued = this.buscarOrden;
    }


    this.busquedaOrdenN(busqued);

  }*/



  /* -------------------------------------------------------------------------- */
  /*                                BUSCAR ORDEN                                */
  /* -------------------------------------------------------------------------- */
  /*busquedaOrdenN(busqueda) {
    this.spinnerBoolean = true;
    this.idSucursal = this._usuario.sucursal!;
    this.perfilUsuario = this._usuario.perfil!;
    //perfil, sucursal, estado
    this.ordenesService.cargarOrdenPaginadoFecha(this.size,parseInt(  this.totalSeleccionado.toString()), busqueda,this.atributoBusqueda, this.perfilUsuario, this.idSucursal, this.estado, this.tipoBusqueda).subscribe((resp) => {
    
      this.spinnerBoolean = false;
      this.ordenes = resp["rows"];
      this.totalElements = resp.total;
    });

  }*/


  /* -------------------------------------------------------------------------- */
  /*                        BUSQUEDA FILTRANDO  DATOS                           */
  /* -------------------------------------------------------------------------- */
  /*updateFilter(event) {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      let busqued = "vacio";
    this.pageNumber = 0;
    if (this.buscarOrden != "") {

      busqued = event.target.value;
    }

    this.busquedaOrdenN(busqued);
      clearTimeout(this.timeout)
    },1000)
   
  }*/


  /* -------------------------------------------------------------------------- */
  /*                               IMPRIMIR ORDEN                               */
  /* -------------------------------------------------------------------------- */
  imprimirOrden(orden, doctor, telefonoDoctor) {

    const pdfWindow = window.open('', '_blank');

    this.ordenesService.generarOrdenTransferencia(
      localStorage.getItem('token'),
      orden,
      doctor,
      telefonoDoctor
    ).subscribe({
      next: (blob) => {
        const url = URL.createObjectURL(blob);
        if (pdfWindow) {
          pdfWindow.location.href = url;
        } else {
          window.open(url, '_blank');
        }
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      },
      error: () => {
        if (pdfWindow) {
          pdfWindow.close();
        }
        this.toastr.error('No se pudo generar la orden digital.', 'Atención', {
          timeOut: 5000,
          closeButton: true,
          progressBar: true
        });
      }
    });

  }

  /* -------------------------------------------------------------------------- */
  /*                             MODAL ASIGNAR ORDEN                            */
  /* -------------------------------------------------------------------------- */
  modalAsignarOrden(basicModal: any, codigoOrden, codigoDoctor, nombreDoctor, nombreCliente) {
    this.modalService.open(basicModal);
    this.codigoOrden = codigoOrden;
    this.codigoDoctor = codigoDoctor;
    this.nombreDoctor = nombreDoctor;
    this.nombreCliente = nombreCliente;
  }



  /* -------------------------------------------------------------------------- */
  /*                      CONSUME REST ASIGNAR ORDEN FISICA                     */
  /* -------------------------------------------------------------------------- */
  asignarSecuencia() {

    if (this.atributoSecuencia == "") {
      this.toastr.info('Ingrese la secuencia fisica', 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true
      });

      return;

    }
    this.spinnerBooleanAsignarOrden = true;
    this.ordenesService.asignarOrdenFisica(
      this.atributoSecuencia,
      this.codigoOrden,
      this.codigoDoctor,
      this.nombreDoctor,
      this.nombreCliente,
      this.atributoSecuencia,
      localStorage.getItem('token')
    ).subscribe((resp) => {


      if (resp == 'ok') {
        this.toastr.success('Orden Física asignada correctamente', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
        this.modalService.dismissAll()
        this.spinnerBooleanAsignarOrden = false;
        this.atributoSecuencia = "";
        this.datatableOrdenes();

      } else {

        this.toastr.error(resp, 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
        this.spinnerBooleanAsignarOrden = false;
        //this.modalService.dismissAll();
        this.atributoSecuencia = "";
        //this.busquedaOrdenN("vacio");
      }

    });

  }


  /* -------------------------------------------------------------------------- */
  /*                          ELIMINAR SECUENCIA FISICA                         */
  /* -------------------------------------------------------------------------- */
  eliminarSecuenciaFisica(orden, secuenciaFisica) {

    Swal.fire({
      icon: 'warning',
      title: '¿Está seguro de eliminar la secuencia física de esta orden?',
      text: 'si no lo está puede cancelar la acción!',
      showCancelButton: true,
      confirmButtonColor: '#0162e8',
      cancelButtonColor: '#FF0000',
      confirmButtonText: 'Si, eliminar!',
      cancelButtonText: 'Cancelar',
      reverseButtons: true

    }).then((result) => {
      if (result.isConfirmed) {
        this.ordenesService.eliminarSecuenciaFisica(
          orden,
          secuenciaFisica,
          localStorage.getItem('token')
        ).subscribe((resp) => {


          if (resp == 'ok') {
            this.toastr.success('Orden Física eliminada correctamente', 'Atención', {
              timeOut: 3000,
              closeButton: true,
              progressBar: true
            });


            this.datatableOrdenes();

          } else {

            this.toastr.error(resp, 'Atención', {
              timeOut: 3000,
              closeButton: true,
              progressBar: true
            });

          }

        });


      }
    })
  }


  /* -------------------------------------------------------------------------- */
  /*                               ELIMINAR ORDEN                               */
  /* -------------------------------------------------------------------------- */
  eliminarOrden(orden) {


    Swal.fire({
      icon: 'warning',
      title: '¿Está seguro de eliminar esta orden?',
      text: 'si no lo está puede cancelar la acción!',
      showCancelButton: true,
      confirmButtonColor: '#0162e8',
      cancelButtonColor: '#FF0000',
      confirmButtonText: 'Si, eliminar!',
      cancelButtonText: 'Cancelar',
      reverseButtons: true

    }).then((result) => {
      if (result.isConfirmed) {
        this.ordenesService.eliminarOrden(
          orden,
          localStorage.getItem('token')
        ).subscribe((resp) => {


          if (resp == 'ok') {
            this.toastr.success('Orden  eliminada correctamente', 'Atención', {
              timeOut: 3000,
              closeButton: true,
              progressBar: true
            });


            this.datatableOrdenes();

          } else {

            this.toastr.error(resp, 'Atención', {
              timeOut: 3000,
              closeButton: true,
              progressBar: true
            });

          }

        });


      }
    })
  }

  /* -------------------------------------------------------------------------- */
  /*                     NOTIFICAR ORDEN PENDIENTE PACIENTE                     */
  /* -------------------------------------------------------------------------- */
  notificarPendientePac(orden, doctor, celDoctor, cliente, celCliente, numOrden) {
    this.compartirOrdenPaciente(orden, 'recordatorio');
  }



  /* -------------------------------------------------------------------------- */
  /*                          NOTIFICAR ORDEN PACIENTE                          */
  /* -------------------------------------------------------------------------- */
  enviarOrdenPac(orden, doctor, celDoctor, cliente, celCliente, numOrden) {
    this.compartirOrdenPaciente(orden, 'orden');
  }

  private compartirOrdenPaciente(
    orden,
    tipo: 'recordatorio' | 'orden'
  ): void {
    const whatsappWindow = window.open('about:blank', '_blank');
    this.spinnerBoolean = true;

    this.ordenesService.crearEnlaceOrdenPaciente(orden).subscribe({
      next: (share) => {
        const field = tipo === 'recordatorio'
          ? 'NOTPAC_ORD'
          : 'NOTPACORD_ORD';

        this.ordenesService.contarOrden(
          field,
          orden,
          localStorage.getItem('token')
        ).subscribe({
          next: () => {
            this.spinnerBoolean = false;
            const link =
              `${environment.apiBaseUrl}/public/order-transfer/` +
              encodeURIComponent(share.token);
            const text = tipo === 'recordatorio'
              ? (
                `Estimado(a) ${share.patientName.toUpperCase()}. ` +
                'Le saludamos de parte de C&M Radiografías y Tomografías ' +
                'Dentales, Ecografías y Laboratorio Clínico. Le recordamos ' +
                `que tiene la orden N.° ${share.orderNumber} pendiente del ` +
                `doctor(a) ${share.doctorName}. Lo esperamos pronto. ` +
                `Puede revisar la orden aquí:\n${link}`
              )
              : link;
            const whatsappUrl =
              `https://api.whatsapp.com/send?phone=${share.patientPhone}` +
              `&text=${encodeURIComponent(text)}`;

            if (whatsappWindow) {
              whatsappWindow.location.href = whatsappUrl;
            } else {
              window.open(whatsappUrl, '_blank');
            }
          },
          error: (error) => {
            whatsappWindow?.close();
            this.spinnerBoolean = false;
            this.toastr.error(
              error?.error?.message ||
                'No fue posible registrar la notificación',
              'Atención'
            );
          }
        });
      },
      error: (error) => {
        whatsappWindow?.close();
        this.spinnerBoolean = false;
        this.toastr.error(
          error?.error?.message ||
            'No fue posible generar el enlace de la orden',
          'Atención'
        );
      }
    });
  }


  /* -------------------------------------------------------------------------- */
  /*                          CAMBIAR RUTA CREAR ORDEN                          */
  /* -------------------------------------------------------------------------- */
  rutaCrearOrden() {


    this.router.navigateByUrl('sistema/crear-orden');
  }
  rutaCrearOrdenSF() {


    this.router.navigateByUrl('sistema/crear-orden-sin-factura');
  }

  rutaCrearOrdenCitaPrevia(){
    this.router.navigateByUrl('sistema/orden-cita-previa');
  }


  /* -------------------------------------------------------------------------- */
  /*                                EDITAR ORDEN                                */
  /* -------------------------------------------------------------------------- */
  editarOrden(idOrden) {
    this.router.navigate(['/sistema/editar-orden', this.makeid(100) + idOrden + this.makeid(100)]);
  }


  /* -------------------------------------------------------------------------- */
  /*                               FACTURAR ORDEN                               */
  /* -------------------------------------------------------------------------- */
  facturarOrden(idOrden) {
    this.router.navigate(['/sistema/facturar-orden', this.makeid(100) + idOrden + this.makeid(100)]);
  }


  /* -------------------------------------------------------------------------- */
  /*                               FACTURAR ORDEN                               */
  /* -------------------------------------------------------------------------- */
  subirImagenes(idOrden) {
    this.router.navigate(['/sistema/subir-imagenes', this.makeid(100) + idOrden + this.makeid(100)]);
  }

  subirImagenesAnalisis(idOrden) {
    this.router.navigate(['/sistema/subir-imagenes-analisis', this.makeid(100) + idOrden + this.makeid(100)]);
  }
  

  cambiarEstadoOrden(idOrden){

    this.ordenesService.cambiarEstadoOrden(
    idOrden,
      localStorage.getItem('token'),
    ).subscribe((resp) => {


      if (resp == "ok") {

        

        this.toastr.success('Enviado correctamente', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
        this.spinnerBoolean = false;
        //location.reload();
        
      } else {
        this.spinnerBoolean = false;
        this.toastr.error(resp, 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
      }
    });

  }


  /* -------------------------------------------------------------------------- */
  /*                         BUSCAR ESTADO POR PESTAÑAS                         */
  /* -------------------------------------------------------------------------- */
  cambiarEstado(estado, tipo) {

    if (this.estadoDT != estado) {

      this.estadoDT = estado;
      this.tipoBusqueda = tipo;
      this.datatableOrdenes();


    }





  }

  consultarOrdenesSubida(estado, tipo){

   this.ordenesService.datatableOrdenesFiltro(
          this.estadoDT,
          this.perfil,
          this.idSucursal,
          this.limite,
          this.pagina,
          this.busqueda,
          this.anioSeleccionado
        ).subscribe(resp => {

          this.ordenes = resp.data;
          this.spinnerBoolean = false;
          

        })

  }
  
  /* -------------------------------------------------------------------------- */
  /*                           GENERAR ALEATORIO ROUTE                          */
  /* -------------------------------------------------------------------------- */
  makeid(length) {
    var result = '';
    var characters = 'ABCDEFGHIJ12345679KLMNOPQRST08765454UVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }


  /* -------------------------------------------------------------------------- */
  /*                                EDITAR ORDEN                                */
  /* -------------------------------------------------------------------------- */
  editarOrdenImagenes(idOrden) {
    this.router.navigate(['/sistema/editar-orden-imagenes', this.makeid(100) + idOrden + this.makeid(100)]);
  }


  /* -------------------------------------------------------------------------- */
  /*                         ENVIAR IMAGENES A PACIENTE                         */
  /* -------------------------------------------------------------------------- */
  /*envioImagenesPaciente(orden, doctor, cliente, numOrden, celCliente, idSucursal, direccionSucursal, tipo) {

    var celularDeCliente = "";
    if (celCliente.includes("+1")) {

      celularDeCliente = celCliente.substring(1);

    } else {

      if (celCliente.length <= 12) {

        celularDeCliente = celCliente.substring(3);

      } else {

        celularDeCliente = celCliente.substring(4);
      }


    }

const SALUDOS = [
  "Hola {NOM_CLI}, 👋",
  "Hola {NOM_CLI}, ¿cómo está? 😊",
  "¡Buen día {NOM_CLI}! ☀️",
  "Buen día {NOM_CLI}, 👋",
  "Estimado(a) {NOM_CLI},",
  "{NOM_CLI}, saludos cordiales.",
  "Hola {NOM_CLI} 🙌",
  "¡Hola {NOM_CLI}! 😃",
  "Buen día {NOM_CLI}. Esperamos se encuentre bien ✅",
  "Hola {NOM_CLI}, gusto en saludarle.",
  "¡Saludos {NOM_CLI}! 👋",
  "Hola nuevamente {NOM_CLI}, 😊",
  "Un gusto saludarle, {NOM_CLI}.",
  "Hola {NOM_CLI} 🤗",
  "¡Hola {NOM_CLI}! Esperamos que todo esté bien.",
  "Buenos días/tardes {NOM_CLI},",
  "{NOM_CLI}, muy buenos días/tardes 👋",
  "Estimado paciente {NOM_CLI},",
  "Querido(a) {NOM_CLI},",
  "Hola {NOM_CLI}, gracias por preferirnos 🙏",
  "Hola {NOM_CLI}, 🌟",
  "Hola {NOM_CLI}, ¿cómo se encuentra hoy?",
  "Buen día {NOM_CLI} ✨",
  "¡Hola {NOM_CLI}! 👌",
  "Saludos cordiales {NOM_CLI},",
  "Hola {NOM_CLI}, 🌈",
  "Hola {NOM_CLI}, un saludo afectuoso.",
  "Estimado(a) {NOM_CLI} 😊",
  "Buen día {NOM_CLI}! Nos alegra contactarle.",
  "Muy buen día {NOM_CLI} ☀️",
  "Hola {NOM_CLI}, esperamos que esté muy bien 🙌",
  "¡Hola {NOM_CLI}! 🤝",
  "Apreciado(a) {NOM_CLI},",
  "Hola {NOM_CLI}, de parte del equipo C&M 👋",
  "Hola {NOM_CLI}, 💙",
  "Hola {NOM_CLI} 🌼",
  "Buen día {NOM_CLI}, le saludamos con gusto 😄",
  "Hola {NOM_CLI}, que tenga un excelente día ☀️",
  "Saludos estimado(a) {NOM_CLI},",
  "Hola {NOM_CLI}, estamos para servirle 🤝",
  "Hola {NOM_CLI}, ✨ ¿cómo va su día?",
  "Hola {NOM_CLI}, gracias por confiar en nosotros 💙",
  "Hola {NOM_CLI}, C&M le saluda 👋",
  "Hola {NOM_CLI}, ¡es un gusto contactarle! 😃",
  "Hola {NOM_CLI}, esperamos que se encuentre bien ✅",
  "Hola {NOM_CLI}, 💫",
  "Muy buen día {NOM_CLI}, estamos atentos a apoyarle 👌",
  "Hola {NOM_CLI} 🎯",
  "¡Hola {NOM_CLI}! Siempre a sus órdenes 🙏",
  "Buen día {NOM_CLI}, equipo C&M a su servicio ✅"
];

const DESPEDIDAS = [
  "Gracias por confiar en C&M Imágenes 🏥",
  "Quedamos atentos ante cualquier consulta ✅",
  "Estamos para servirle cuando lo necesite 🙌",
  "Le deseamos un excelente día ☀️",
  "Agradecemos su preferencia 🙏",
  "Es un placer atenderle 🌟",
  "Gracias por elegirnos 💙",
  "Seguimos a su disposición 🤝",
  "Que tenga un bonito día 😊",
  "Gracias por su confianza ✨",
  "Estamos disponibles para ayudarle ✅",
  "Un cordial saludo 👋",
  "Cualquier duda, estamos pendientes 📲",
  "Esperamos verle pronto 🌼",
  "Gracias por preferir nuestros servicios 🏥",
  "Estamos siempre para apoyarle 🙌",
  "Reciba un cordial saludo 👌",
  "Quedamos atentos a su visita 📍",
  "Que tenga un excelente resto del día ☀️",
  "Muchas gracias por su tiempo 💙",
  "Estamos aquí para usted ✅",
  "Seguimos atentos 💪",
  "Gracias por elegir una atención responsable 🌟",
  "Éxitos en su día ✨",
  "C&M agradece su visita 🙏",
  "Seguimos disponibles en todo momento 📲",
  "Gracias por su confianza en nosotros 💙",
  "Nos alegra atenderle 😊",
  "Fue un gusto contactarle 👋",
  "Cualquier consulta estamos aquí ✅",
  "Que su día sea maravilloso ☀️",
  "Su salud es nuestra prioridad 🏥",
  "Atentamente, el equipo de C&M 🤝",
  "Esperamos que vuelva pronto ✨",
  "Muchas gracias por su confianza 🙌",
  "Estamos para cuidar su bienestar 💙",
  "Nos mantenemos atentos ✅",
  "Hasta pronto 👋",
  "Gracias por su atención 🙏",
  "Nuestro equipo está para servirle 🌐",
  "Le enviamos un cordial saludo 🌼",
  "Gracias por su tiempo y preferencia ✨",
  "Quedamos atentos a cualquier requerimiento 📲",
  "Es un honor poder atenderle 💙",
  "Gracias por elegir calidad en salud 🏥",
  "Un gusto servirle cada día 🙌",
  "¡Le esperamos pronto! 😊",
  "Estamos atentos si necesita más detalles ✅",
  "Le enviamos nuestros mejores deseos ✨",
  "Su satisfacción es importante para nosotros ⭐"
];

function pickRandom(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

function crearMensaje() {
  const saludo = pickRandom(SALUDOS).replace("{NOM_CLI}", cliente);
  const despedida = pickRandom(DESPEDIDAS);

  return `${saludo}\nSus imágenes médicas ya están disponibles.\n*N. de orden:* ${numOrden}\n*Sucursal:* ${direccionSucursal}\n${despedida}`;
}

    var cel = celCliente;
    var msg = crearMensaje();

    this.ordenesService.envioImagenesWhatsapp(
      celularDeCliente,
      msg,
      orden,
      cliente,
      idSucursal,
      localStorage.getItem('token'),
    ).subscribe((resp) => {


      if (resp == "ok") {

        this.ordenesService.contarOrden(
          "NOTPACIMG_ORD",
          orden,
          localStorage.getItem('token'),
        ).subscribe((resp) => {

          var ordenN = numOrden.toString().split(' ').join('%20');
          var nombreN = cliente.toString().split(' ').join('%20');
          var doctorN = doctor.toString().split(' ').join('%20');

          if (resp == "ok") {



          }

        });
        this.toastr.success('Enviado correctamente', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
        this.spinnerBoolean = false;
        if (tipo == "envio-paciente") {
          this.dtenvioImagenesPacientes();
          //this.cambiarEstado('con-imagenes', 'envio-imagenes-paciente');


        } else {

          this.dtenvioImagenesDoctor();
        }

      } else {
        this.spinnerBoolean = false;
        this.toastr.error(resp, 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
      }
    });



  }*/


  /* -------------------------------------------------------------------------- */
  /*                           ENVIAR IMAGENES DOCTOR                           */
  /* -------------------------------------------------------------------------- */
  envioImagenesDoctor(orden, doctor, cliente, numOrden, celDoctor, idSucursal, direccionSucursal, tipo) {





    this.spinnerBoolean = true;

    celDoctor = "" + celDoctor;
    var cel = celDoctor.substring(1);
    var empresa = "*C&M Radiografías, Tomografías dentales, Ecografías y Laboratorio Clínico*";
    var msg = "Estimado Dr(a): " + doctor.toUpperCase() + ". Le saludamos de parte del " + empresa + " para informarle que las imagenes del paciente " + cliente.toUpperCase() + " con N. de orden: " + numOrden + " *ya se encuentran disponible en la APP.*\n*SUCURSAL:* " + direccionSucursal;

    /*this.ordenesService.envioImagenesWhatsapp(
      celDoctor.substring(1),
      msg,
      orden,
      cliente,
      idSucursal,
      localStorage.getItem('token'),
    ).subscribe((resp) => {


      if (resp == "ok") {
        this.ordenesService.contarOrden(
          "NOTDOCIMG_ORD",
          orden,
          localStorage.getItem('token'),
        ).subscribe((resp) => {

          var ordenN = numOrden.toString().split(' ').join('%20');
          var nombreN = cliente.toString().split(' ').join('%20');
          var doctorN = doctor.toString().split(' ').join('%20');

          if (resp == "ok") {


          }

        });
        this.toastr.success('Enviado correctamente', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
        this.spinnerBoolean = false;


        this.dtenvioImagenesDoctor();


      } else {
        this.spinnerBoolean = false;
        this.toastr.error(resp, 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
      }
    });*/




  }



  /* -------------------------------------------------------------------------- */
  /*                         ENVIAR IMAGENES A PACIENTE                         */
  /* -------------------------------------------------------------------------- */
  envioResultados(orden, tipo) {
    const clave = `completo:${tipo}`;
    if (!this.iniciarEnvioResultado(clave)) {
      return;
    }
    this.spinnerBoolean = true;
    this.ordenesService.enviarResultados(
          orden,
          tipo,
        ).subscribe((resp) => {
          if (resp == "ok") {
            this.marcarResultadoEnviado(clave);
            this.toastr.success('Enviado correctamente', 'Atención', {
              timeOut: 3000,
              closeButton: true,
              progressBar: true
            });
            this.spinnerBoolean = false;

          } else {
            this.liberarEnvioResultado(clave);
            this.spinnerBoolean = false;
            this.toastr.error(resp, 'Atención', {
              timeOut: 3000,
              closeButton: true,
              progressBar: true
            });
          }
        }, (error) => {
          this.liberarEnvioResultado(clave);
          this.spinnerBoolean = false;
          this.toastr.error(
            error?.error?.message || 'No fue posible enviar los resultados',
            'Atención'
          );
        });
  }

  /*envioImagenesPacienteAtendida(orden, doctor, cliente, numOrden, celCliente, idSucursal, direccionSucursal, tipo) {

    var celularDeCliente = "";
    if (celCliente.includes("+1")) {

      celularDeCliente = celCliente.substring(1);
`
    } else {

      if (celCliente.length <= 12) {

        celularDeCliente = celCliente.substring(3);

      } else {

        celularDeCliente = celCliente.substring(4);
      }


    }

    this.spinnerBoolean = true;
    this.ordenesService.contarOrden(
      "NOTPACIMG_ORD",
      orden,
      localStorage.getItem('token'),
    ).subscribe((resp) => {

      var ordenN = numOrden.toString().split(' ').join('%20');
      var nombreN = cliente.toString().split(' ').join('%20');
      var doctorN = doctor.toString().split(' ').join('%20');

      const SALUDOS = [
  "Hola {NOM_CLI}, 👋",
  "Hola {NOM_CLI}, ¿cómo está? 😊",
  "¡Buen día {NOM_CLI}! ☀️",
  "Buen día {NOM_CLI}, 👋",
  "Estimado(a) {NOM_CLI},",
  "{NOM_CLI}, saludos cordiales.",
  "Hola {NOM_CLI} 🙌",
  "¡Hola {NOM_CLI}! 😃",
  "Buen día {NOM_CLI}. Esperamos se encuentre bien ✅",
  "Hola {NOM_CLI}, gusto en saludarle.",
  "¡Saludos {NOM_CLI}! 👋",
  "Hola nuevamente {NOM_CLI}, 😊",
  "Un gusto saludarle, {NOM_CLI}.",
  "Hola {NOM_CLI} 🤗",
  "¡Hola {NOM_CLI}! Esperamos que todo esté bien.",
  "Buenos días/tardes {NOM_CLI},",
  "{NOM_CLI}, muy buenos días/tardes 👋",
  "Estimado paciente {NOM_CLI},",
  "Querido(a) {NOM_CLI},",
  "Hola {NOM_CLI}, gracias por preferirnos 🙏",
  "Hola {NOM_CLI}, 🌟",
  "Hola {NOM_CLI}, ¿cómo se encuentra hoy?",
  "Buen día {NOM_CLI} ✨",
  "¡Hola {NOM_CLI}! 👌",
  "Saludos cordiales {NOM_CLI},",
  "Hola {NOM_CLI}, 🌈",
  "Hola {NOM_CLI}, un saludo afectuoso.",
  "Estimado(a) {NOM_CLI} 😊",
  "Buen día {NOM_CLI}! Nos alegra contactarle.",
  "Muy buen día {NOM_CLI} ☀️",
  "Hola {NOM_CLI}, esperamos que esté muy bien 🙌",
  "¡Hola {NOM_CLI}! 🤝",
  "Apreciado(a) {NOM_CLI},",
  "Hola {NOM_CLI}, de parte del equipo C&M 👋",
  "Hola {NOM_CLI}, 💙",
  "Hola {NOM_CLI} 🌼",
  "Buen día {NOM_CLI}, le saludamos con gusto 😄",
  "Hola {NOM_CLI}, que tenga un excelente día ☀️",
  "Saludos estimado(a) {NOM_CLI},",
  "Hola {NOM_CLI}, estamos para servirle 🤝",
  "Hola {NOM_CLI}, ✨ ¿cómo va su día?",
  "Hola {NOM_CLI}, gracias por confiar en nosotros 💙",
  "Hola {NOM_CLI}, C&M le saluda 👋",
  "Hola {NOM_CLI}, ¡es un gusto contactarle! 😃",
  "Hola {NOM_CLI}, esperamos que se encuentre bien ✅",
  "Hola {NOM_CLI}, 💫",
  "Muy buen día {NOM_CLI}, estamos atentos a apoyarle 👌",
  "Hola {NOM_CLI} 🎯",
  "¡Hola {NOM_CLI}! Siempre a sus órdenes 🙏",
  "Buen día {NOM_CLI}, equipo C&M a su servicio ✅"
];

const DESPEDIDAS = [
  "Gracias por confiar en C&M Imágenes 🏥",
  "Quedamos atentos ante cualquier consulta ✅",
  "Estamos para servirle cuando lo necesite 🙌",
  "Le deseamos un excelente día ☀️",
  "Agradecemos su preferencia 🙏",
  "Es un placer atenderle 🌟",
  "Gracias por elegirnos 💙",
  "Seguimos a su disposición 🤝",
  "Que tenga un bonito día 😊",
  "Gracias por su confianza ✨",
  "Estamos disponibles para ayudarle ✅",
  "Un cordial saludo 👋",
  "Cualquier duda, estamos pendientes 📲",
  "Esperamos verle pronto 🌼",
  "Gracias por preferir nuestros servicios 🏥",
  "Estamos siempre para apoyarle 🙌",
  "Reciba un cordial saludo 👌",
  "Quedamos atentos a su visita 📍",
  "Que tenga un excelente resto del día ☀️",
  "Muchas gracias por su tiempo 💙",
  "Estamos aquí para usted ✅",
  "Seguimos atentos 💪",
  "Gracias por elegir una atención responsable 🌟",
  "Éxitos en su día ✨",
  "C&M agradece su visita 🙏",
  "Seguimos disponibles en todo momento 📲",
  "Gracias por su confianza en nosotros 💙",
  "Nos alegra atenderle 😊",
  "Fue un gusto contactarle 👋",
  "Cualquier consulta estamos aquí ✅",
  "Que su día sea maravilloso ☀️",
  "Su salud es nuestra prioridad 🏥",
  "Atentamente, el equipo de C&M 🤝",
  "Esperamos que vuelva pronto ✨",
  "Muchas gracias por su confianza 🙌",
  "Estamos para cuidar su bienestar 💙",
  "Nos mantenemos atentos ✅",
  "Hasta pronto 👋",
  "Gracias por su atención 🙏",
  "Nuestro equipo está para servirle 🌐",
  "Le enviamos un cordial saludo 🌼",
  "Gracias por su tiempo y preferencia ✨",
  "Quedamos atentos a cualquier requerimiento 📲",
  "Es un honor poder atenderle 💙",
  "Gracias por elegir calidad en salud 🏥",
  "Un gusto servirle cada día 🙌",
  "¡Le esperamos pronto! 😊",
  "Estamos atentos si necesita más detalles ✅",
  "Le enviamos nuestros mejores deseos ✨",
  "Su satisfacción es importante para nosotros ⭐"
];

function pickRandom(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

function crearMensaje() {
  const saludo = pickRandom(SALUDOS).replace("{NOM_CLI}", cliente);
  const despedida = pickRandom(DESPEDIDAS);

  return `${saludo}\nSus imágenes médicas ya están disponibles.\n*N. de orden:* ${numOrden}\n*Sucursal:* ${direccionSucursal}\n${despedida}`;
}

    var cel = celCliente;
    

      if (resp == "ok") {
        var cel = celCliente;
        var empresa = "*C&M Radiografías, Tomografías dentales, Ecografías y Laboratorio Clínico*";
       var msg = crearMensaje();
        this.ordenesService.envioImagenesWhatsapp(
          celularDeCliente,
          msg,
          orden,
          cliente,
          idSucursal,
          localStorage.getItem('token'),
        ).subscribe((resp) => {


          if (resp == "ok") {
            this.toastr.success('Enviado correctamente', 'Atención', {
              timeOut: 3000,
              closeButton: true,
              progressBar: true
            });
            this.spinnerBoolean = false;
            location.reload();

          } else {

            this.toastr.error(resp, 'Atención', {
              timeOut: 3000,
              closeButton: true,
              progressBar: true
            });
          }
        });

      }

    });

  }*/


  /* -------------------------------------------------------------------------- */
  /*                           ENVIAR IMAGENES DOCTOR                           */
  /* -------------------------------------------------------------------------- */
  envioImagenesDoctorAtendida(orden, doctor, cliente, numOrden, celDoctor, idSucursal, direccionSucursal, tipo) {


 const SALUDOS_DOC = [
    "Estimado Dr. {NOM_DOC},",
    "Estimado Dr(a). {NOM_DOC},",
    "Dr. {NOM_DOC}, buen día 👋",
    "Buen día Dr(a). {NOM_DOC},",
    "Dr. {NOM_DOC}, un gusto saludarle.",
    "Dr(a). {NOM_DOC}, saludos cordiales.",
    "Cordial saludo Dr(a). {NOM_DOC},",
    "Dr. {NOM_DOC}, ¿cómo está? 😊",
    "Dr(a). {NOM_DOC}, esperamos se encuentre bien ✅",
    "Apreciado Dr. {NOM_DOC},",
    "Apreciado(a) Dr(a). {NOM_DOC},",
    "Muy buen día Dr. {NOM_DOC},",
    "Dr(a). {NOM_DOC}, 👋",
    "Respetado Dr. {NOM_DOC},",
    "Respetado(a) Dr(a). {NOM_DOC},",
    "Hola Dr. {NOM_DOC},",
    "Hola Dr(a). {NOM_DOC} 👋",
    "Bendecido día Dr(a). {NOM_DOC}, ☀️",
    "Dr. {NOM_DOC}, gracias por su dedicación 🩺",
    "Dr(a). {NOM_DOC}, C&M le saluda 👋",
    "Dr. {NOM_DOC}, esperamos que todo marche bien ✅",
    "Dr. {NOM_DOC}, le contactamos con gusto.",
    "Muy buenos días/tardes Dr(a). {NOM_DOC},",
    "Dr(a). {NOM_DOC}, confiamos que esté muy bien 🙌",
    "Dr. {NOM_DOC}, es un gusto mantenernos en contacto 🤝",
    "Dr(a). {NOM_DOC}, saludos de parte de nuestro equipo 🏥",
    "Dr. {NOM_DOC}, nos alegra saludarle 😊",
    "Estimado especialista {NOM_DOC},",
    "Dr(a). {NOM_DOC}, 💼",
    "Dr. {NOM_DOC}, a su servicio siempre ✅",
    "Dr(a). {NOM_DOC}, le saludamos con aprecio",
    "Reconocido Dr. {NOM_DOC}, 🌟",
    "Celebre Dr(a). {NOM_DOC},",
    "Doctor {NOM_DOC},",
    "Buenas tardes Dr(a). {NOM_DOC},",
    "Muy buenos días Dr. {NOM_DOC}, ☀️",
    "Distinguid@ Dr(a). {NOM_DOC},",
    "Dr. {NOM_DOC}, esperamos poder servirle 👌",
    "Dr(a). {NOM_DOC}, agradecemos su labor médica 💙",
    "Dr. {NOM_DOC}, salud y éxitos en su jornada 🌟",
    "Dr(a). {NOM_DOC} 🙏",
    "Hola distinguido Dr. {NOM_DOC},",
    "Dr. {NOM_DOC}, siempre a su disposición",
    "Dr. {NOM_DOC}, confiamos esté teniendo un buen día ✨",
    "Dr(a). {NOM_DOC}, reciba un cordial saludo 👋",
    "Dr. {NOM_DOC}, estamos atentos a colaborar 🩺",
    "Dr(a). {NOM_DOC}, su apoyo es importante 💙",
    "Dr. {NOM_DOC}, gracias por su compromiso con los pacientes 🙌",
    "Dr(a). {NOM_DOC}, gracias por su dedicación 🌐",
    "Dr. {NOM_DOC}, un fuerte saludo de C&M ✅"
  ];

  const CIERRES_DOC = [
    "Gracias por su confianza en C&M Imágenes 🏥",
    "Agradecemos su colaboración con nuestros servicios ✅",
    "Estamos a disposición para cualquier aclaración 🩺",
    "Quedamos atentos ante cualquier requerimiento 📲",
    "Gracias por su ardua labor en la salud 💙",
    "Nuestro equipo está para asistirle cuando lo requiera 🤝",
    "Siempre comprometidos con el bienestar del paciente 🙌",
    "C&M agradece su apoyo profesional 🌟",
    "Seguimos disponibles para nuevos estudios ✅",
    "Cualquier duda, estamos pendientes de usted 📲",
    "Agradecemos su trabajo en beneficio de la comunidad médica 🏥",
    "Seguimos coordinando con su valioso criterio clínico 👌",
    "Gracias por su labor diaria a favor de la salud 🙏",
    "Estamos listos para atender sus próximas solicitudes ✨",
    "Un cordial saludo del equipo C&M 👋",
    "Esperamos continuar trabajando juntos 🤝",
    "Quedamos atentos a más indicaciones 🩺",
    "Nuestro compromiso es con sus pacientes 💙",
    "Estamos siempre para apoyar su diagnóstico ✅",
    "Gracias por su preferencia en diagnóstico médico 🏥",
    "A su servicio cuando lo necesite 🙌",
    "Un honor apoyar su ejercicio médico 🌟",
    "Estamos para acompañar su gestión clínica 🤝",
    "Gracias por elegir nuestro servicio de imágenes 🩻",
    "Seguiremos a su disposición 📲",
    "Éxitos en su jornada de atención ☀️",
    "Su trabajo es vital para nuestra comunidad 🙏",
    "Un fuerte abrazo profesional 👋",
    "Seguimos atentos a sus indicaciones ✅",
    "Que tenga una excelente jornada médica 🌟",
    "Le enviamos un cordial saludo profesional 👌",
    "Gracias por su pronta revisión clínica 🩺",
    "Estamos atentos si requiere informe complementario 📄",
    "Gracias por confiar la atención de sus pacientes 💙",
    "Quedamos atentos a nuevos estudios 🔬",
    "Siempre comprometidos con la precisión diagnóstica 📍",
    "Atentamente, equipo C&M Imágenes ✅",
    "Un gusto colaborar con usted 🤝",
    "Estamos para brindar soporte al diagnóstico 🧠",
    "Cualquier comentario será bien recibido 📩",
    "Gracias por su dedicación y vocación 🌼",
    "Apreciamos su compromiso profesional 🎯",
    "Que tenga un excelente resto del día ☀️",
    "Estamos atentos para continuar asistiendo 🩺",
    "A su disposición para futuras atenciones 👋",
    "Gracias por permitirnos ser parte del proceso clínico 🙏",
    "Seguimos disponibles 24/7 en horarios extendidos ✅",
    "Con gusto atenderemos más requerimientos 📌",
    "Un saludo cordial y profesional del equipo C&M 💙",
    "Será un placer continuar colaborando 🏥",
    "Gracias por elegir excelencia en imágenes médicas ✨"
  ];
function pickRandom(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

function crearMensaje() {
  const saludo = pickRandom(SALUDOS_DOC).replace("{NOM_DOC}", doctor.toUpperCase());
  const despedida = pickRandom(CIERRES_DOC);

  return `${saludo}\nlas imágenes médicas del paciente ${cliente} ya están disponibles.\n*N. de orden:* ${numOrden}\n*Sucursal:* ${direccionSucursal}\n${despedida}`;
}


    this.spinnerBoolean = true;
    this.ordenesService.contarOrden(
      "NOTDOCIMG_ORD",
      orden,
      localStorage.getItem('token'),
    ).subscribe((resp) => {

      var ordenN = numOrden.toString().split(' ').join('%20');
      var nombreN = cliente.toString().split(' ').join('%20');
      var doctorN = doctor.toString().split(' ').join('%20');

      if (resp == "ok") {
        celDoctor = "" + celDoctor;
        var cel = celDoctor.substring(1);
        var empresa = "*C&M Radiografías, Tomografías dentales, Ecografías y Laboratorio Clínico*";
        
        var msg = crearMensaje();
        /* Flujo retirado: envío de imágenes legacy.
        this.ordenesService.envioImagenesWhatsapp(
          celDoctor.substring(1),
          msg,
          orden,
          cliente,
          idSucursal,
          localStorage.getItem('token'),
        ).subscribe((resp) => {


          if (resp == "ok") {
            this.toastr.success('Enviado correctamente', 'Atención', {
              timeOut: 3000,
              closeButton: true,
              progressBar: true
            });
            this.spinnerBoolean = false;


            //location.reload();


          } else {

            this.toastr.error(resp, 'Atención', {
              timeOut: 3000,
              closeButton: true,
              progressBar: true
            });
          }
        }); */

      }

    });

  }


  /* -------------------------------------------------------------------------- */
  /*                                BUSCAR DOCTOR                               */
  /* -------------------------------------------------------------------------- */

  buscarDoctor(event: any) {


    if (event.key.toString() != "ArrowDown" && event.key.toString() != "ArrowUp" && event.key.toString() != "Enter") {

      let doctor = event.target.value;
      this.doctoreslist = [];
      this.doctoreslist.push({

        "datos": "Cargando....",
        "codigo": ""
      });

      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {

        this.doctoresService.buscarDoctor(localStorage.getItem('token'), 0, 0, doctor, "crear-orden").subscribe((resp) => {

          this.doctoreslist = [];
          if (resp.total >= 1) {



            resp.rows.forEach((currentValue, index) => {



              this.doctoreslist.push({

                "datos": "CEDULA: " + currentValue.CodVendedor + ", NOMBRE: " + currentValue.NombreVendedor,
                "codigo": currentValue.COD_VEN
              });

            });
          }


        }, (err) => {
          this.doctoreslist = [];
        })


        clearTimeout(this.timeout)
      }, 1000)

    }




  }


  /* -------------------------------------------------------------------------- */
  /*                        OBTENER CLIENTE SELECCIONADO                        */
  /* -------------------------------------------------------------------------- */
  obtenerDoctorSeleccionado(name) {


    if (this.selectedDoctor === null || this.selectedDoctor == "") {


      this.doctoreslist = [];
      this.codigoDoctor = "";
      this.telefonoDoctor = "";
      this.nombreDoctor = "";
      return;

    }

    this.doctoresService.mostrarDoctoresNormal(localStorage.getItem('token'), "COD_VEN", name).subscribe((resp) => {

      var content = JSON.parse(JSON.stringify(resp.rows));
      if (!content?.length || !content[0]?.CodVendedor) {
        this.codigoDoctor = "";
        this.telefonoDoctor = "";
        this.nombreDoctor = "";
        return;
      }

      this.codigoDoctor = content[0].CodVendedor;
      this.telefonoDoctor = content[0].TelefonoMovil;
      this.nombreDoctor = content[0].NombreVendedor;
    }, (err) => {
      this.codigoDoctor = "";
      this.telefonoDoctor = "";
      this.nombreDoctor = "";
    })

  }


  /* -------------------------------------------------------------------------- */
  /*                           MODIFICAR DOCTOR MODAL                           */
  /* -------------------------------------------------------------------------- */
  modificarDoctor(basicModal: any, numeroOrden, idOrden, secuenciaFisica,nombreDoctor) {

    this.modalService.open(basicModal);
    this.idOrden = idOrden;
    this.numeroOrden = numeroOrden;
    this.secuenciaFisica = secuenciaFisica;
    this.nombreDoctorModificar = nombreDoctor;
  }


  /* -------------------------------------------------------------------------- */
  /*                          MODIFICAR DOCTOR SERVICE                          */
  /* -------------------------------------------------------------------------- */
  updateDoctor() {


    this.spinnerBooleanAsignarOrden = true;


    this.ordenesService.actualizarDoctor(
      this.codigoDoctor,
      this.idOrden,
      this.numeroOrden,
      this.secuenciaFisica,
      localStorage.getItem('token'),

    ).subscribe((resp) => {

      if (resp == "ok") {

        this.toastr.success("Doctor actualizado correctamente", 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
        this.spinnerBooleanAsignarOrden = false;
        this.modalService.dismissAll();
        this.cambiarEstado('con-imagenes', 'normal');
      } else {

        this.spinnerBooleanAsignarOrden = false;
        this.toastr.error(resp, 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
      }

    });
  }

  private procesarEnvioTomografiaEmail(
    orden,
    item,
    link,
    alCompletar?: () => void
  ): void {
    let enlace = String(link ?? '').trim();
    if (!enlace || enlace === 'null') {
      enlace = String(
        prompt('Ingrese el link de la tomografía subida:') ?? ''
      ).trim();
    }

    if (!enlace) {
      this.toastr.error(
        'Ingrese un link para proceder a enviar',
        'Atención',
        {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        }
      );
      return;
    }

    const tipo: 'tomography' | 'dicom' =
      String(item).includes('DIC') ? 'dicom' : 'tomography';
    const clave = this.claveEnvioTomografia(item, 'email');
    if (!this.iniciarEnvioResultado(clave)) {
      return;
    }

    this.spinnerBoolean = true;
    this.ordenesService.enviarEmailTomografiaNode(
      orden,
      tipo,
      enlace
    ).subscribe({
      next: () => {
        this.marcarResultadoEnviado(clave);
        this.spinnerBoolean = false;
        this.toastr.success('Enviado correctamente', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
        alCompletar?.();
      },
      error: (error) => {
        this.liberarEnvioResultado(clave);
        this.spinnerBoolean = false;
        this.toastr.error(
          error?.error?.message ||
            'No fue posible enviar la tomografía por correo electrónico',
          'Atención',
          {
            timeOut: 4000,
            closeButton: true,
            progressBar: true
          }
        );
      }
    });
  }

  private procesarEnvioTomografiaWhatsapp(
    orden,
    item,
    link,
    alCompletar?: () => void,
    controlarEstado = false
  ): void {
    let enlace = String(link ?? '').trim();
    if (!enlace || enlace === 'null') {
      enlace = String(
        prompt('Ingrese el link de la tomografía subida:') ?? ''
      ).trim();
    }

    if (!enlace) {
      this.toastr.error(
        'Ingrese un link para proceder a enviar',
        'Atención',
        {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        }
      );
      return;
    }

    const clave = this.claveEnvioTomografia(item, 'whatsapp');
    if (controlarEstado && !this.iniciarEnvioResultado(clave)) {
      return;
    }
    const tipo: 'tomography' | 'dicom' =
      String(item).includes('DIC') ? 'dicom' : 'tomography';

    this.spinnerBoolean = true;
    this.ordenesService.enviarWhatsappTomografiaNode(
      orden,
      tipo,
      enlace
    ).subscribe({
      next: () => {
        if (controlarEstado) {
          this.marcarResultadoEnviado(clave);
        }
        this.spinnerBoolean = false;
        this.toastr.success('Enviado correctamente', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
        alCompletar?.();
      },
      error: (error) => {
        if (controlarEstado) {
          this.liberarEnvioResultado(clave);
        }
        this.spinnerBoolean = false;
        this.toastr.error(
          error?.error?.message ||
            'No fue posible enviar la tomografía por WhatsApp',
          'Atención',
          {
            timeOut: 4000,
            closeButton: true,
            progressBar: true
          }
        );
      }
    });
  }

  /* -------------------------------------------------------------------------- */
  /*                              OBTENER SUCURSAL                              */
  /* -------------------------------------------------------------------------- */
  returnSucursal(sucursal): string {

    if (sucursal == "1") {

      return "MATRIZ"
    }

    if (sucursal == "2") {

      return "ALBORADA"
    }

    if (sucursal == "3") {

      return "VIA A DAULE"
    }

    if (sucursal == "4") {

      return "PORTETE"
    }

    if (sucursal == "6") {

      return "DURAN"
    }

    if (sucursal == "8") {

      return "SUR"
    }

    if (sucursal == "11") {

      return "CERRADO"
    }



    return "";
  }


  /* -------------------------------------------------------------------------- */
  /*                               FORMATEAR VALOR                              */
  /* -------------------------------------------------------------------------- */
  obtenerValor(total): string {


    return parseFloat(total).toFixed(2);

  }


  /* -------------------------------------------------------------------------- */
  /*                         OBTENER TOTAL DE SECUENCIAS                        */
  /* -------------------------------------------------------------------------- */
  totalSecuencia(secuencias): any {

    if (secuencias != "null" && secuencias != null) {

      return JSON.parse(secuencias).length;
    } else {

      return 1;
    }


  }


  /* -------------------------------------------------------------------------- */
  /*                         TRANSFORMAR JSON SECUENCIAS                        */
  /* -------------------------------------------------------------------------- */
  returnJSON(secuencias): any {


    return JSON.parse(secuencias);

  }


  /* -------------------------------------------------------------------------- */
  /*                       REDIRIGIR EDITAR ORDEN PAQUETE                       */
  /* -------------------------------------------------------------------------- */
  crearOrdenPaquete(secuencias, idTransaccion,) {


    this.router.navigate(['/sistema/crear-orden-paquete', this.makeid(100) + btoa(secuencias + "," + idTransaccion) + this.makeid(100)]);

  }


  /* -------------------------------------------------------------------------- */
  /*                    MODAL CÓDIGOS DISPONIBLES PAQUETE                       */
  /* -------------------------------------------------------------------------- */
  getCodigosTexto(post: any): string {
    try {
      const usaSecuencia = post.secuenciaUsada != null && post.secuenciaUsada != 'null';
      if (usaSecuencia) {
        return JSON.parse(post.secuenciaUsada).join(' ');
      } else {
        return JSON.parse(post.DET_TRAC).map((s: any) => s.observacion).join(' ');
      }
    } catch {
      return '';
    }
  }

  abrirModalCodigosPaquete(post: any, modal: any) {
    this.busquedaCodigoPaquete = '';
    this.paginaCodigoPaquete = 1;
    this.paqueteSeleccionadoCod = post;

    const usaSecuencia = post.secuenciaUsada != null && post.secuenciaUsada != 'null';
    if (usaSecuencia) {
      this.codigosPaqueteModal = this.returnJSON(post.secuenciaUsada).map((s: any) => ({ codigo: s, etiqueta: s }));
    } else {
      this.codigosPaqueteModal = this.returnJSON(post.DET_TRAC).map((s: any) => ({ codigo: s.observacion, etiqueta: s.observacion }));
    }

    this.codigosPaqueteFiltrados = [...this.codigosPaqueteModal];
    this.totalPaginasCodigos = Math.ceil(this.codigosPaqueteFiltrados.length / this.itemsPorPaginaPaquete);
    this.modalCodigosPaqueteRef = this.modalService.open(modal, { size: 'lg', centered: true, scrollable: true });
  }

  filtrarCodigosPaquete() {
    const termino = this.busquedaCodigoPaquete.toLowerCase().trim();
    this.paginaCodigoPaquete = 1;
    this.codigosPaqueteFiltrados = termino
      ? this.codigosPaqueteModal.filter(c => c.etiqueta.toLowerCase().includes(termino))
      : [...this.codigosPaqueteModal];
    this.totalPaginasCodigos = Math.ceil(this.codigosPaqueteFiltrados.length / this.itemsPorPaginaPaquete);
  }

  codigosPaquetePaginados(): any[] {
    const inicio = (this.paginaCodigoPaquete - 1) * this.itemsPorPaginaPaquete;
    return this.codigosPaqueteFiltrados.slice(inicio, inicio + this.itemsPorPaginaPaquete);
  }

  getPaginasCodigos(): number[] {
    return Array.from({ length: this.totalPaginasCodigos }, (_, i) => i + 1);
  }

  seleccionarCodigoPaquete(codigo: string) {
    if (this.modalCodigosPaqueteRef) {
      this.modalCodigosPaqueteRef.close();
    }
    this.crearOrdenPaquete(codigo, this.paqueteSeleccionadoCod.COD_TRAC);
  }


  /* -------------------------------------------------------------------------- */
  /*                        ABRIR MODAL MODIFICAR CORREO                        */
  /* -------------------------------------------------------------------------- */
  modificarCorreo(basicModal: any, codigoDoctor, idOrden) {

    this.codigoDoctor = codigoDoctor;
    this.idOrden = idOrden;

    this.modalService.open(basicModal);
  }


  /* -------------------------------------------------------------------------- */
  /*                        ABRIR MODAL ACTUALIZAR CORREO                       */
  /* -------------------------------------------------------------------------- */
  actualizarCorreo() {
    this.spinnerBooleanAsignarOrden = true;


    this.ordenesService.actualizarCorreoDoctor(
      this.codigoDoctor,
      this.idOrden,
      this.nuevoCorreoElectronico,
      localStorage.getItem('token'),
    ).subscribe((resp) => {

      if (resp == "ok") {

        this.toastr.success("Doctor actualizado correctamente", 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
        this.spinnerBooleanAsignarOrden = false;
        this.modalService.dismissAll();
        //this.cambiarEstado('correo-invalido', 'normal');
        location.reload();
      } else {

        this.spinnerBooleanAsignarOrden = false;
        this.toastr.error(resp, 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
      }

    });
  }


  /* -------------------------------------------------------------------------- */
  /*                   ENVIO LINK TOMOGRAFIA TOMOGRAFIA DICON                   */
  /* -------------------------------------------------------------------------- */
  enviarTomografiaEmail(orden, item, tipo, doctor, paciente, numeroOrden) {
    this.procesarEnvioTomografiaEmail(
      orden,
      item,
      '',
      () => this.dtTomografiaDicom()
    );
  }


  /* -------------------------------------------------------------------------- */
  /*                      ENVIAR WHATSAPP TOMOGRAFIA DICON                      */
  /* -------------------------------------------------------------------------- */
  enviarWSEmail(orden, item, tipo, doctor, paciente, numeroOrden) {
    this.procesarEnvioTomografiaWhatsapp(
      orden,
      item,
      '',
      () => this.dtTomografiaDicom()
    );
  }


  /* -------------------------------------------------------------------------- */
  /*                   ENVIO LINK TOMOGRAFIA TOMOGRAFIA DICON                   */
  /* -------------------------------------------------------------------------- */
  enviarTomografiaEmailNormal(orden, item, tipo, doctor, paciente, numeroOrden, link) {
    this.procesarEnvioTomografiaEmail(
      orden,
      item,
      link,
      () => this.dtTomografia()
    );
  }



  /* -------------------------------------------------------------------------- */
  /*                         ENVIO LINK WHATSAAP NORMAL                         */
  /* -------------------------------------------------------------------------- */
  enviarWSEmailNormal(orden, item, tipo, doctor, paciente, numeroOrden, link) {
    this.procesarEnvioTomografiaWhatsapp(
      orden,
      item,
      link,
      () => this.dtTomografia()
    );
  }




  /* -------------------------------------------------------------------------- */
  /*                   ENVIO LINK TOMOGRAFIA TOMOGRAFIA DICON                   */
  /* -------------------------------------------------------------------------- */
  enviarTomografiaEmailAtendidas(orden, item, tipo, doctor, paciente, numeroOrden, link) {
    this.procesarEnvioTomografiaEmail(orden, item, link);
  }



  /* -------------------------------------------------------------------------- */
  /*                         ENVIO LINK WHATSAAP NORMAL                         */
  /* -------------------------------------------------------------------------- */
  enviarWSEmailAtendidas(orden, item, tipo, doctor, paciente, numeroOrden, link) {
    this.procesarEnvioTomografiaWhatsapp(
      orden,
      item,
      link,
      undefined,
      true
    );
  }



  /* -------------------------------------------------------------------------- */
  /*                           BUSCAR SECUENCIA FISICA                          */
  /* -------------------------------------------------------------------------- */
  buscarSecuenciaFisica(event) {

    if (event.key.toString() != "ArrowDown" && event.key.toString() != "ArrowUp" && event.key.toString() != "Enter") {

      let secuencia = event.target.value;
      this.secuenciasList = [];
      this.secuenciasList.push({

        "datos": "Cargando....",
        "codigo": ""
      });



      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {

        this.ordenesService.buscarSecuenciaFisica(localStorage.getItem('token'), "secuencia-fisica-busqueda", "NUM_SECORD", secuencia).subscribe((resp) => {

          this.secuenciasList = [];
          if (resp.total >= 1) {


            resp.rows.forEach((currentValue, index) => {



              this.secuenciasList.push({

                "datos": currentValue.NUM_SECORD,
                "codigo": currentValue.COD_SECORD
              });

            });
          }


        }, (err) => {
          this.secuenciasList = [];
        })


        clearTimeout(this.timeout)
      }, 1000)

    }
  }


  /* -------------------------------------------------------------------------- */
  /*                       OBTENER SECUENCIA SELECCIONADA                       */
  /* -------------------------------------------------------------------------- */
  validarSecuenciaFisica() {

    if (this.selected == "") {
      this.toastr.error("Por favor ingrese una secuencia.", 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true
      });

      return;

    }
    this.spinnerBooleanAsignarOrden = true;
    this.ordenesService.buscarSecuenciaFisica(localStorage.getItem('token'), "secuencia-fisica", "NUM_SECORD", this.selected).subscribe((resp) => {

      var content = JSON.parse(JSON.stringify(resp.rows));

      if (content.length >= 1) {

        if (content[0].CLI_SECORD != "" && content[0].CLI_SECORD != "null" && content[0].CLI_SECORD != null) {

          this.pacienteSecuencia = content[0].CLI_SECORD;
          this.doctorSecuencia = content[0].NOMDOC_SECORD;
          this.asesorSencuencia = content[0].ASEASIG_BLOCK;
          this.selected = "";
          this.spinnerBooleanAsignarOrden = false;
        } else {
          this.toastr.success("Secuencia disponible.", 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });
          this.router.navigate(['/sistema/crear-orden-fisica', this.makeid(100) + content[0].COD_SECORD + this.makeid(100)]);
          this.spinnerBooleanAsignarOrden = false;
          this.modalService.dismissAll();


        }
      } else {

        this.toastr.error("El número de orden que digitó no se encuentra en nuestros registros.", 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
        this.spinnerBooleanAsignarOrden = false;
      }


    }, (err) => {
      console.warn('request_error_suppressed', err);
    })


  }



  /* -------------------------------------------------------------------------- */
  /*                       OBTENER SECUENCIA SELECCIONADA                       */
  /* -------------------------------------------------------------------------- */
  validarSecuenciaFisicaSF() {

    if (this.selected == "") {
      this.toastr.error("Por favor ingrese una secuencia.", 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true
      });

      return;

    }
    this.spinnerBooleanAsignarOrden = true;
    this.ordenesService.buscarSecuenciaFisica(localStorage.getItem('token'), "secuencia-fisica", "NUM_SECORD", this.selected).subscribe((resp) => {

      var content = JSON.parse(JSON.stringify(resp.rows));

      if (content.length >= 1) {

        if (content[0].CLI_SECORD != "" && content[0].CLI_SECORD != "null" && content[0].CLI_SECORD != null) {

          this.pacienteSecuencia = content[0].CLI_SECORD;
          this.doctorSecuencia = content[0].NOMDOC_SECORD;
          this.asesorSencuencia = content[0].ASEASIG_BLOCK;
          this.selected = "";
          this.spinnerBooleanAsignarOrden = false;
        } else {
          this.toastr.success("Secuencia disponible.", 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });
          this.router.navigate(['/sistema/crear-orden-fisica-sf', this.makeid(100) + content[0].COD_SECORD + this.makeid(100)]);
          this.spinnerBooleanAsignarOrden = false;
          this.modalService.dismissAll();


        }
      } else {

        this.toastr.error("El número de orden que digitó no se encuentra en nuestros registros.", 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
        this.spinnerBooleanAsignarOrden = false;
      }


    }, (err) => {
      console.warn('request_error_suppressed', err);
    })


  }



  modalSecuenciaFisica(basicModal: any) {
    this.modalService.open(basicModal);

  }

  /* -------------------------------------------------------------------------- */
  /*                              TOMOGRAFIA DICOM                              */
  /* -------------------------------------------------------------------------- */
  dtTomografiaDicom() {
    this.tomoModo = 'dicon';
    this.busquedaTom = '';
    this.paginaTom = 1;
    this.cargarTom();
  }

  /* -------------------------------------------------------------------------- */
  /*                                 TOMOGRAFIA                                 */
  /* -------------------------------------------------------------------------- */
  dtTomografia() {
    this.tomoModo = 'normal';
    this.busquedaTom = '';
    this.paginaTom = 1;
    this.cargarTom();
  }

  /** Trae la página actual de la bandeja de tomografía desde el backend. */
  private cargarTom(): void {
    this.spinnerBoolean = true;
    this.ordenesService
      .dtTomografiaDicom(this.tomoModo, this.paginaTom, this.itemsPorPaginaTom, this.busquedaTom)
      .subscribe({
        next: (resp) => {
          this.ordenesTomData = Array.isArray(resp?.rows) ? resp.rows : [];
          this.totalTom = resp?.total ?? 0;
          this.spinnerBoolean = false;
        },
        error: () => {
          this.ordenesTomData = [];
          this.totalTom = 0;
          this.spinnerBoolean = false;
        }
      });
  }

  filtrarTom(): void {
    // Búsqueda server-side con debounce (la consulta del backend es liviana).
    this.paginaTom = 1;
    if (this.tomoSearchTimer) {
      clearTimeout(this.tomoSearchTimer);
    }
    this.tomoSearchTimer = setTimeout(() => this.cargarTom(), 350);
  }

  irPaginaTom(pagina: number): void {
    const destino = Math.min(Math.max(1, pagina), this.totalPaginasTom);
    if (destino === this.paginaTom) {
      return;
    }
    this.paginaTom = destino;
    this.cargarTom();
  }

  get ordenesTomPaginadas(): any[] {
    // El backend ya entrega solo la página actual.
    return this.ordenesTomData;
  }

  get totalPaginasTom(): number {
    return Math.max(1, Math.ceil(this.totalTom / this.itemsPorPaginaTom));
  }

  getPageRangeTom(): (number | string)[] {
    const total = this.totalPaginasTom;
    const current = this.paginaTom;
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
    const pages: (number | string)[] = [1];
    if (current > 3) pages.push('...');
    for (let i = Math.max(2, current - 1); i <= Math.min(total - 1, current + 1); i++) pages.push(i);
    if (current < total - 2) pages.push('...');
    pages.push(total);
    return pages;
  }

  dtPendienteCitaPrevia(estado:any) {

    // this.reload();

    // this.estadoDT = 'pendiente';
    const that = this;
    that.ordenesPendienteCita = [];
    this.myTable = false;

    let lastPage = 0;
    let lastSearchText = "";
    this.dtOptionsCitaPendiente = {
      language: LanguageApp.spanish_datatables,
      pagingType: 'full_numbers',
      pageLength: 10,
      displayStart: lastPage, // Last Selected Page
      search: { search: lastSearchText }, // Last Searched Text
      serverSide: true,
      // processing: true,
      responsive: true,
      retrieve: true,
      orderClasses: false,
      processing: true,
      deferRender: true,
      searchDelay: 1500,
      ajax: (dataTablesParameters: any, callback) => {


        this.pagina = dataTablesParameters.start;
        this.busqueda = dataTablesParameters.search.value;
        this.limite = dataTablesParameters.length;

        this.ordenesService.datatableOrdenesPendienteCitaPrevia(
          estado,
          this.perfil,
          this.nombreSucursal,
          this.limite,
          this.pagina,
          this.busqueda,
          this.anioSeleccionado
        ).subscribe(resp => {

          this.ordenesPendienteCita = resp.data;
          this.spinnerBoolean = false;
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: []
          });

        })

      }
    }
  }

  dtFacturadasCitaPrevia(estado:any) {

    // this.reload();

    // this.estadoDT = 'pendiente';
    const that = this;
    that.ordenesFacturadasCita = [];
    this.myTable = false;

    let lastPage = 0;
    let lastSearchText = "";
    this.dtOptionsFacturadasCita = {
      language: LanguageApp.spanish_datatables,
      pagingType: 'full_numbers',
      pageLength: 10,
      displayStart: lastPage, // Last Selected Page
      search: { search: lastSearchText }, // Last Searched Text
      serverSide: true,
      // processing: true,
      responsive: true,
      retrieve: true,
      orderClasses: false,
      processing: true,
      deferRender: true,
      searchDelay: 1500,
      ajax: (dataTablesParameters: any, callback) => {


        this.pagina = dataTablesParameters.start;
        this.busqueda = dataTablesParameters.search.value;
        this.limite = dataTablesParameters.length;

        this.ordenesService.datatableOrdenesPendienteCitaPrevia(
          estado,
          this.perfil,
          this.nombreSucursal,
          this.limite,
          this.pagina,
          this.busqueda,
          this.anioSeleccionado
        ).subscribe(resp => {

          this.ordenesFacturadasCita = resp.data;
          this.calendarOptions = {
            initialView: 'dayGridMonth',
            plugins: [dayGridPlugin],
            locale: esLocale,
            events: resp.data.map(item => ({
              title: item.NOM_CLI,
              start: item.fechaOrden,
              codigo: item.COD_ORD
            })),
            eventClick: this.handleEventClick.bind(this),
          };


          this.spinnerBoolean = false;
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: []
          });

        })

      }
    }
  }

  handleEventClick(arg){
    Swal.fire({
      icon: 'warning',
      title: '¿Está seguro de subir las imagenes de la orden?',
      text: 'si no lo está puede cancelar la acción!',
      showCancelButton: true,
      confirmButtonColor: '#0162e8',
      cancelButtonColor: '#FF0000',
      confirmButtonText: 'Si, Subir!',
      cancelButtonText: 'Cancelar',
      reverseButtons: false

    }).then((result) => {
      if (result.isConfirmed) {
        this.router.navigate(['/sistema/subir-imagenes', this.makeid(100) + arg.event.extendedProps.codigo + this.makeid(100)]);
      }
    })

  }

  imprimirTicketLaboratorio(orden) {

    const pdfWindow = window.open('', '_blank');

    this.ordenesService.generarTicketMuestraLaboratorio(
      localStorage.getItem('token'),
      orden,
      'nuevo'
    ).subscribe({
      next: (blob) => {
        const url = URL.createObjectURL(blob);
        if (pdfWindow) {
          pdfWindow.location.href = url;
        } else {
          window.open(url, '_blank');
        }
        setTimeout(() => URL.revokeObjectURL(url), 30000);
      },
      error: () => {
        if (pdfWindow) {
          pdfWindow.close();
        }
        this.toastr.error('No se pudo generar el ticket de muestras.', 'Atención');
      }
    });

  }


  imprimirResultado(orden, fechaOrden) {
    const fecha = String(fechaOrden ?? '').slice(0, 10);
    const idOrden = encodeURIComponent(String(orden));
    const url = fecha >= '2024-12-10'
      ? `https://cmsalud.ec/resultados-orion/resultados-${idOrden}.pdf`
      : `${this.linkAnterior}/radiografia/extensiones/tcpdf/pdf/resultados-finales.php?orden=${idOrden}`;

    window.open(url, '_blank');
  }

  enviarResultadosWS(orden, destinatario: 'doctor' | 'paciente') {
    const clave = `laboratorio:${destinatario}:whatsapp`;
    if (!this.iniciarEnvioResultado(clave)) {
      return;
    }
    this.spinnerBoolean = true;

    const envio = destinatario == 'doctor'
      ? this.ordenesService
          .enviarResultadosLaboratorioDoctorWhatsappNode(orden)
      : this.ordenesService
          .enviarResultadosLaboratorioPacienteWhatsappNode(orden);

    envio.subscribe({
      next: () => {
        this.marcarResultadoEnviado(clave);
        this.spinnerBoolean = false;
        this.toastr.success('Enviado correctamente', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
      },
      error: (error) => {
        this.liberarEnvioResultado(clave);
        this.spinnerBoolean = false;
        this.toastr.error(
          error?.error?.message ||
            `No fue posible enviar los resultados al ${destinatario} por WhatsApp`,
          'Atención',
          {
            timeOut: 4000,
            closeButton: true,
            progressBar: true
          }
        );
      }
    });
  }

  visualizarOrdenFisica(linkFile){

    if(linkFile.includes("doc")){
      window.open(`https://www.sistema.cmsalud.ec/radiografia/vistas/img/multimedia/${linkFile}`,"_blank");
    }else{
      window.open(`http://drive.google.com/uc?export=view&id=${linkFile}`,"_blank");
    }
  }


  enviarResultadosEmail(orden, destinatario: 'doctor' | 'paciente') {
    const clave = `laboratorio:${destinatario}:email`;
    if (!this.iniciarEnvioResultado(clave)) {
      return;
    }
    this.spinnerBoolean = true;

    const envio = destinatario == 'doctor'
      ? this.ordenesService.enviarResultadosLaboratorioDoctorNode(orden)
      : this.ordenesService.enviarResultadosLaboratorioPacienteNode(orden);

    envio.subscribe({
      next: () => {
        this.marcarResultadoEnviado(clave);
        this.spinnerBoolean = false;
        this.toastr.success('Enviado correctamente', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
      },
      error: (error) => {
        this.liberarEnvioResultado(clave);
        this.spinnerBoolean = false;
        this.toastr.error(
          error?.error?.message ||
            `No fue posible enviar los resultados al ${destinatario}`,
          'Atención',
          {
            timeOut: 4000,
            closeButton: true,
            progressBar: true
          }
        );
      }
    });
  }


  /* -------------------------------------------------------------------------- */
  /*                       ENVIAR FACTURA POR WHATSAPP                          */
  /* -------------------------------------------------------------------------- */
  enviarFacturaCliente(idOrden) {
    this.spinnerBoolean = true;
    this.ordenesService.enviarFacturaCliente(
      idOrden
    ).subscribe({
      next: () => {
        this.spinnerBoolean = false;
        this.toastr.success("Enviado correctamente", 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
      },
      error: (error) => {
        this.spinnerBoolean = false;
        this.toastr.error(
          error?.error?.message ||
            'No fue posible enviar la factura por WhatsApp',
          'Atención',
          {
            timeOut: 4000,
            closeButton: true,
            progressBar: true
          }
        );
      }
    });
  }
  enviarFacturaSRI(idOrden) {
    this.spinnerBoolean = true;
    this.ordenesService.enviarFacturaSRI(idOrden).subscribe({
      next: (sri) => {
        this.spinnerBoolean = false;
        const mensaje = sri?.email?.ok === false
          ? 'Factura autorizada; no fue posible enviar el correo al paciente'
          : 'Factura enviada, autorizada y notificada correctamente';
        this.toastr.success(mensaje, 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
        this.datatableOrdenes();
      },
      error: (error) => {
        this.spinnerBoolean = false;
        this.toastr.error(
          error?.error?.message ||
            'No fue posible procesar la factura con el SRI',
          'Atención',
          {
          timeOut: 5000,
          closeButton: true,
          progressBar: true
          }
        );
      }
    });
  }


  /* -------------------------------------------------------------------------- */
  /*                           ENVIAR ACCESO WHATSAPP                           */
  /* -------------------------------------------------------------------------- */
  enviarAccesosWSPaciente(nombre, cedula, telefono) {





    this.spinnerBoolean = true;
    this.ordenesService.enviarAccesosPaciente(
      nombre,
      cedula,
      telefono,
      this.idSucursal
    ).subscribe((resp) => {

      if (resp == "ok") {

        this.toastr.success("El proceso de envío se completó exitosamente", 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
        this.spinnerBoolean = false;
        location.reload();
      } else {

        this.toastr.error(resp, 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });

      }









    });


  }


  verInformeRxCorporal(idOrden){
    this.abrirPdfRx(
      this.informesRxService.generarInformeCorporal(idOrden),
      'No fue posible generar el informe RX corporal'
    );
  }

  private abrirPdfRx(request: any, errorMessage: string): void {
    const pdfWindow = window.open('', '_blank');
    request.subscribe({
      next: (blob: Blob) => {
        const url = URL.createObjectURL(blob);
        if (pdfWindow) {
          pdfWindow.location.href = url;
        } else {
          window.open(url, '_blank');
        }
        setTimeout(() => URL.revokeObjectURL(url), 60_000);
      },
      error: (error) => {
        pdfWindow?.close();
        this.toastr.error(
          error?.error?.message || errorMessage,
          'Atención',
          {
            timeOut: 4000,
            closeButton: true,
            progressBar: true
          }
        );
      }
    });
  }

  verInformesRx(orden: any): void {
    const token = localStorage.getItem('token') || '';
    this.informesRxService.listarInformesPorOrden(orden.COD_ORD, token).subscribe({
      next: (resp: any) => {
      const rows = resp?.rows || [];
      if (!rows.length) {
        this.toastr.info('No hay servicios de informes RX asociados para esta orden.', 'Atención', {
          timeOut: 3500,
          closeButton: true,
          progressBar: true
        });
        return;
      }

      const htmlItems = rows.map((r: any) => {
        const listo = Number(r.reportReady) === 1;
        const statusBadge = listo
          ? '<span class="rx-report-badge rx-report-badge--ready">Listo</span>'
          : '<span class="rx-report-badge rx-report-badge--pending">Pendiente</span>';
        const action = listo
          ? `<button type="button" class="rx-report-link rx-report-open" data-service-id="${Number(r.COD_PRO)}">Visualizar</button>`
          : '<span class="rx-report-disabled">No disponible</span>';

        return `
          <div class="rx-report-item">
            <div class="rx-report-item__meta">
              <div class="rx-report-item__name">${r.NOM_PRO || 'Servicio'}</div>
              <div class="rx-report-item__code">${r.CODN_PRO || ''}</div>
            </div>
            <div class="rx-report-item__actions">
              ${statusBadge}
              ${action}
            </div>
          </div>
        `;
      }).join('');

      Swal.fire({
        title: `Informes RX`,
        html: `
          <div class="rx-report-modal">
            <p class="rx-report-modal__subtitle">Orden ${orden.NUM_ORD}</p>
            <div class="rx-report-list">${htmlItems}</div>
          </div>
        `,
        width: 780,
        confirmButtonText: 'Cerrar',
        customClass: {
          popup: 'rx-report-popup',
          confirmButton: 'rx-report-confirm'
        },
        didOpen: () => {
          Swal.getPopup()
            ?.querySelectorAll<HTMLButtonElement>('.rx-report-open')
            .forEach((button) => {
              button.addEventListener('click', () => {
                const serviceId = Number(button.dataset['serviceId']);
                if (!Number.isInteger(serviceId) || serviceId <= 0) {
                  return;
                }
                this.abrirPdfRx(
                  this.informesRxService.generarInformeServicio(
                    orden.COD_ORD,
                    serviceId
                  ),
                  'No fue posible generar el informe RX'
                );
              });
            });
        }
      });
      },
      error: () => {
        this.toastr.error('No se pudieron cargar los informes RX de la orden.', 'Atención', {
          timeOut: 3500,
          closeButton: true,
          progressBar: true
        });
      }
    });
  }
  imprimirTicket(orden, codOrden, numeroFacturaOrden) {
    const pdfWindow = window.open('', '_blank');

    this.ordenesService.generarFacturaClienteNode(
      localStorage.getItem('token'),
      numeroFacturaOrden,
      'Electronica',
      codOrden
    ).subscribe({
      next: (blob) => {
        const url = URL.createObjectURL(blob);
        if (pdfWindow) {
          pdfWindow.location.href = url;
        } else {
          window.open(url, '_blank');
        }
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      },
      error: () => {
        if (pdfWindow) {
          pdfWindow.close();
        }
        this.toastr.error('No se pudo generar el ticket de la factura.', 'Atención', {
          timeOut: 5000,
          closeButton: true,
          progressBar: true
        });
      }
    });
  }

  imprimirReciboInterno(codOrden, numeroFacturaOrden) {
    const pdfWindow = window.open('', '_blank');

    this.ordenesService.generarReciboInterno(
      localStorage.getItem('token'),
      numeroFacturaOrden,
      'Electronica',
      codOrden
    ).subscribe({
      next: (blob) => {
        const url = URL.createObjectURL(blob);
        if (pdfWindow) {
          pdfWindow.location.href = url;
        } else {
          window.open(url, '_blank');
        }
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      },
      error: () => {
        if (pdfWindow) {
          pdfWindow.close();
        }
        this.toastr.error('No se pudo generar el recibo interno.', 'Atención', {
          timeOut: 5000,
          closeButton: true,
          progressBar: true
        });
      }
    });
  }

  mostrarModalSubirOrden(id, modalSubirOrden){
    this.modalService.open(modalSubirOrden);
    this.idOrdenFisc = id;
}

  triggerMobileUpload(orderId: string): void {
    if (!orderId) {
      return;
    }
    this.pendingMobileOrderId = orderId;
    this.idOrdenFisc = orderId;

    const input = this.mobileCameraInput?.nativeElement;
    if (input) {
      input.value = '';
      input.click();
    } else {
      this.toastr.error('No se pudo abrir la cámara del dispositivo.', 'Atención', {
        timeOut: 5000,
        closeButton: true,
        progressBar: true
      });
    }
  }

  handleMobileCameraCapture(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input?.files && input.files[0];
    if (!file || !this.pendingMobileOrderId) {
      return;
    }
    this.processOrdenFisicaFile(file, true);
    input.value = '';
  }

  ordenFisica(event){

    const file =  event.target.files[0];
    this.processOrdenFisicaFile(file, false);
  }

  private processOrdenFisicaFile(file: File, autoUpload: boolean): void {
    if (!file) {
      return;
    }

    if (autoUpload) {
      this.mobileUploading = true;
      this.openMobileUploadingModal();
    }

    this.preparePhysicalOrderDataUrl(file).then((dataUrl) => {
      this.txtOrdenFisica = dataUrl;
      if (autoUpload) {
        this.subirOrdenFisica(true);
        this.pendingMobileOrderId = undefined;
      }
    }).catch(() => {
      if (autoUpload) {
        this.mobileUploading = false;
        this.closeMobileUploadingModal();
      }
      this.toastr.error('No se pudo procesar la imagen capturada.', 'Atención', {
        timeOut: 5000,
        closeButton: true,
        progressBar: true
      });
    });
  }

  private preparePhysicalOrderDataUrl(file: File): Promise<string> {
    if (!String(file.type || '').startsWith('image/')) {
      return this.readFileAsDataUrl(file);
    }

    return this.compressImageFile(file).catch(() =>
      this.readFileAsDataUrl(file)
    );
  }

  private readFileAsDataUrl(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = () => reject(reader.error || new Error('file_read_failed'));
      reader.readAsDataURL(file);
    });
  }

  private compressImageFile(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const image = new Image();
        image.onload = () => {
          const maxDimension = this.mobilePhysicalOrderMaxDimension;
          const scale = Math.min(
            1,
            maxDimension / Math.max(image.width, image.height)
          );
          const width = Math.max(1, Math.round(image.width * scale));
          const height = Math.max(1, Math.round(image.height * scale));
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const context = canvas.getContext('2d');
          if (!context) {
            reject(new Error('canvas_context_unavailable'));
            return;
          }
          context.drawImage(image, 0, 0, width, height);
          resolve(canvas.toDataURL(
            'image/jpeg',
            this.mobilePhysicalOrderJpegQuality
          ));
        };
        image.onerror = () => reject(new Error('image_load_failed'));
        image.src = reader.result as string;
      };
      reader.onerror = () => reject(reader.error || new Error('file_read_failed'));
      reader.readAsDataURL(file);
    });
  }

  subirOrdenFisica(autoTriggered: boolean = false){
    if(this.spinnerBooleanAsignarOrden) return;
      this.spinnerBooleanAsignarOrden = true;
       this.ordenesService.subirOrdenFisica(
        
        this.idOrdenFisc,
        this.txtOrdenFisica,
        localStorage.getItem('token'),
     
       
      ).subscribe((resp) => {
  
        this.spinnerBooleanAsignarOrden = false;
        if(resp == "ok"){
          this.toastr.success("Subida correctamente", 'Atención', {
            timeOut: 7000,
            closeButton: true,
            progressBar: true
          });
            if(!autoTriggered){
              this.modalService.dismissAll();
              location.reload();
              return;
            }
            this.mobileUploading = false;
            this.closeMobileUploadingModal();
            location.reload();
            return;
        }else{
          this.toastr.success("Multimedia actualizada correctamente y subida a la nube C&M", 'Atención', {
            timeOut: 7000,
            closeButton: true,
            progressBar: true
          });
          if(!autoTriggered){
            this.router.navigateByUrl('sistema/inicio');
          } else {
            this.mobileUploading = false;
            this.closeMobileUploadingModal();
            location.reload();
          }
          
        }
     
  
      }, () => {
        if (autoTriggered) {
          this.mobileUploading = false;
          this.closeMobileUploadingModal();
        }
      });
  }


  verOrdenFisica(orden: string): void {
    this.viewExistingMobilePreview(orden, true);
  }

  viewExistingMobilePreview(orden: string, showDownload: boolean = false): void {
    if (!orden) {
      return;
    }
    this.showDownloadButton = showDownload;
    this.mobilePreviewImage = (typeof orden === 'string' && orden.includes('amazonaws'))
      ? orden
      : `https://sistema.cmsalud.ec/radiografia/vistas/img/multimedia/${orden}`;
    this.openMobilePreviewModal();
  }

  private openMobilePreviewModal(): void {
    if (!this.mobilePreviewModal) {
      return;
    }
    this.mobilePreviewRef = this.modalService.open(this.mobilePreviewModal, {
      centered: true,
      size: 'lg'
    });
  }

  private openMobileUploadingModal(): void {
    if (!this.mobileUploadingModal) {
      return;
    }
    this.closeMobileUploadingModal();
    this.mobileUploadingRef = this.modalService.open(this.mobileUploadingModal, {
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
  }

  private closeMobileUploadingModal(): void {
    if (this.mobileUploadingRef) {
      this.mobileUploadingRef.close();
      this.mobileUploadingRef = undefined;
    }
  }
}

export class LanguageApp {
  public static spanish_datatables = {
    processing: "Procesando...",
    search: "Buscar:",
    lengthMenu: "Mostrar _MENU_ registros",
    info: "Mostrando desde _START_ al _END_ de _TOTAL_ elementos",
    infoEmpty: "Mostrando ningún elemento.",
    infoFiltered: "(filtrado _MAX_ elementos total)",
    infoPostFix: "",
    loadingRecords: "Cargando registros...",
    zeroRecords: "No se encontraron registros",
    emptyTable: "No hay datos disponibles en la tabla",
    paginate: {
      first: "Primero",
      previous: "Ant",
      next: "Sig",
      last: "Último"
    },
    aria: {
      sortAscending: ": Activar para ordenar la tabla en orden ascendente",
      sortDescending: ": Activar para ordenar la tabla en orden descendente"
    }
  }

}
